import React, {useEffect, useMemo, useRef, useState} from 'react'
import {
  ParagraphText,
  Checkbox,
  Button,
  Input,
  Select,
} from '@thryvlabs/maverick'
import {
  COUNTRIES,
  CC_CURRENCIES,
  VALID_TLDS,
  MC_2_0_PLANS,
  MC_2_0_PREMIERPLANS,
  MC_2_0_SIGNATUREPLANS,
  GEO_ADDON_CODES,
} from '../../utils/constants'
import {resolveApplicableFees} from '../../utils/feeUtils'
import {CatalogSectionContainer} from '../ui/command-center-layout'
import {SEOValidation} from './seo-validation'
import {PaymentTypeValidation} from './payment-type-validation'
import {OnboardingRequired} from './onboarding-required'
import {OnboardingFeeRequired} from './onboardingfee-required'
import {IncludeOnboardingToggle} from './include-onboarding-toggle'
import {SEOSummary} from './SeoSummary'
import {DomainValidation} from './domain-validation'
import {KeapDomainValidation} from './keap-domain-validation'
import {ThryvLeadsValidation} from './thryv-leads-validation'
import {WebsiteSettingsModal} from './website-settings-modal'
import {SliderRange} from '../slider-range'
import {toast} from 'react-toastify'
import {useUserFeatures} from '../../context/user-features-context'
import {
  isTgpFoundationFamilyCode,
  isTgpFoundationBlockingCode,
  isTgpFoundationDowngrade,
  isThryvBasicCode,
} from '../../utils/tgp-catalog-flags'
import {EaidValidation} from './eaid-validation'
import dayjs from 'dayjs'
import {formatPrice} from '../../utils/currency-format'
import {seoKeywordsIcon, keapMaxIcon} from '../../assets'
import {marketingCenterIcon} from '../../assets'
import {seoPowerboostIcon} from '../../assets'
import {reverseGreenPlusIcon, thryvSucessServicesIcon} from '../../assets'
import LeadsIcon from '../../assets/Leads Icon.png'
import {
  MC_PLANS,
  BC_PLANS,
  MC_2_0_SIGPREMIERPLANS,
  CC_THRYV_SUCCESS_SERVICES_CODES,
  THRYV_STARTER_CODES,
  GROWTH_PACKAGES,
} from '../../utils/constants'
import {
  RETAIN_WEBSITE_MODAL_STATES,
  RetainWebsiteModal,
} from './retain-website-modal'
import {RetainWebsiteDowngradeModal} from './retain-website-downgrade-modal'
import {QuantityComponent} from '../add-on-components/quantity-component'
import {structuredClone} from 'core-js'
import {SearchDropdown} from './lead-lift-dropdown'
import {
  searchOptions,
  getAmountToQuantityMap,
} from '../../utils/lift-lead-options'
import {useLocation} from 'react-router'
import {client} from '../../utils/api-client'
const ITEM_CONFIG = {
  '5 Extra Website Pages': {
    max: 250,
    range: 5,
    hasSlider: true,
  },
  'Professional Designed Logo': {
    max: 100,
    range: 1,
    hasInput: true,
  },
}

// Geo tiers share one slider config; the cap comes from the catalog's maxQty,
// so a tier capped at 1 gets no slider.
// Matches both the legacy 'Geo Add-On' name and the renamed 'Thryv Geo
// Expansion' prefix so old catalog/subscription data keeps working.
const isGeoExpansionPlan = name =>
  Boolean(name?.includes('Geo Add-On') || name?.includes('Thryv Geo Expansion'))

const getItemConfig = plan => {
  if (ITEM_CONFIG[plan?.name]) return ITEM_CONFIG[plan.name]
  if (!isGeoExpansionPlan(plan?.name)) return undefined
  const max = Number(plan.maxQty)
  return max > 1 ? {max, range: 1, hasSlider: true} : undefined
}

const checkIfAdded = (options, itemName, optionsType) => {
  if (optionsType === 'ent') {
    return options.some(({entitlements}) =>
      entitlements?.some(({name}) => name === itemName),
    )
  }
  if (optionsType === 'app') {
    return options.some(({name}) => name === itemName)
  }
}

const formatEntitlementLabel = (name, quantity, isCanAusNz) => {
  const displayName =
    name === 'Custom Video' && isCanAusNz ? 'QuickStart Video' : name
  const hasQuantity =
    quantity !== undefined && quantity !== null && quantity !== ''

  return hasQuantity ? `${displayName} {${quantity}}` : displayName
}

const NEW_SEO_CODE = 'seobase-5-thryv-m2m'

function Options({
  apps,
  selectedCountry,
  selectedPlan,
  setSelectedPlan,
  selectedCentersAndApps,
  setSelectedCentersAndApps,
  selectedOptions,
  setSelectedOptions,
  proposalId,
  setProposalId,
  proposalValidation,
  alphaSEOFromRecurly,
  alphaProposalId,
  setAlphaProposalId,
  alphaDomain,
  setAlphaDomain,
  alphaAmount,
  setAlphaAmount,
  // categories,
  // setCategories,
  // geos,
  // setGeos,
  isExternalDomain,
  setIsExternalDomain,
  alphaKeyCount,
  setAlphaKeyCount,
  alphaPowerboostCount,
  setAlphaPowerboostCount,
  diableValidateAndProposalInput,
  setProposalValidation,
  mcDomainConfig,
  setMcDomainConfig,
  tlDomainConfig,
  setTlDomainConfig,
  llDomainConfig,
  setLlDomainConfig,
  existingMc2DomainValue,
  paymentType,
  setPaymentType,
  onboardingRequired,
  setOnboardingRequired,
  onboardingFeeRequired,
  setOnboardingFeeRequired,
  includeOnboarding,
  setIncludeOnboarding,
  thryvLeadsId,
  setThryvLeadsId,
  thryvLeadsValidation,
  setThryvLeadsValidation,
  futureBillingDate,
  setFutureBillingDate,
  sensisSiteDomain,
  setSensisSiteDomain,
  quantity,
  setQuantity,
  seatQty,
  oneTimeFees,
  centers,
  isSEOMBGDisabled,
  setIsSEOMBGDisabled,
  defaultCentersAndApps,
  seoDomainConfig,
  setSeoDomainConfig,
  hvacDomainConfig,
  setHvacDomainConfig,
  isWebsiteSettingsModalVisible,
  setIsWebsiteSettingsModalVisible,
  isWebsiteValid,
  setIsWebsiteValid,
  setIsEaidFound,
  isEaidFound,
  cohortEaid,
  setCohortEaid,
  upgradePaymentPreview,
  setUpgradePaymentPreview,
  setAllowInvoice,
  isLegacyUpgradeAllowed,
  setIsLegacyUpgradeAllowed,
  thryvId,
  setIsCohort,
  hasPaidDesignFee,
  hasPaidOnboardingFee,
  isNewTLMCAccessible,
  keapAccount = false,
  keapDomainConfig,
  isWebsiteDesignFeeWaived,
  setKeapDomainConfig,
  retainWebsiteModalState,
  setRetainWebsiteModalState,
  mc20WebsiteDowngradeModalState,
  setMc20WebsiteDowngradeModalState,
  mc20WebsiteDowngradePlanName,
  setMc20WebsiteDowngradePlanName,
  keapTrailAppId,
  setKeapTrailAppId,
  isFreeTrailCustomer,
  setIsFreeTrailCustomer,
  setKeapTextVoiceQty,
  setKeapAddContactsQty,
  selectedAdditionalContactOption,
  setSelectedAdditionalContactOption,
  setKeapAddContactsQtyAnnual,
  selectedAdditionalContactOptionAnnual,
  setSelectedAdditionalContactOptionAnnual,
  selectedKeapTextVoice,
  setSelectedKeapTextVoice,
  setKeapTextVoiceQtyAnnual,
  selectedKeapTextVoiceAnnual,
  setSelectedKeapTextVoiceAnnual,
  keapAddContactsRecurlyQty,
  keapAddContactsRecurlyQtyAnnual,
  keapTextVoiceRecurlyQtyAnnual,
  keapTextVoiceRecurlyQty,
  keapAddUsersRecurlyQty,
  keapAddUsersRecurlyQtyAnnual,
  selectedKcpOption,
  setSelectedKcpOption,
  selectedAdditionalContactOptionGraphlyAnnual,
  setSelectedAdditionalContactOptionGraphlyAnnual,
  keapAddContactsRecurlyQtyGraphlyAnnual,
  setKeapAddContactsQtyGraphlyAnnual,
  plusThisPremiumRecurlyQtyAnnual,
  selectedPlusThisPremiumAnnual,
  setSelectedPlusThisPremiumAnnual,
  setPlusThisPremiumQtyGraphlyAnnual,
  selectedAdditionalContactOptionGraphlyM2m,
  setSelectedAdditionalContactOptionGraphlyM2m,
  keapAddContactsRecurlyQtyGraphlyM2m,
  setKeapAddContactsQtyGraphlyM2m,
  plusThisPremiumRecurlyQtyM2m,
  selectedPlusThisPremiumM2m,
  setSelectedPlusThisPremiumM2m,
  setPlusThisPremiumQtyGraphlyM2m,
  all5PlanPrices,
  kcpRecurlyOption,
  kccRecurlyOption,
}) {
  const userFeatures = useUserFeatures()
  const {MC_Downgrade_Access, Enable_TGP_Downgrade} = useUserFeatures()
  const {pathname} = useLocation()
  const isUpgradeFlow = pathname === '/order/upgrade'
  // if (
  //   selectedPlan?.code === 'addon-5-keap-addusers-m2m' &&
  //   keapAddUsersRecurlyQty &&
  //   keapAddUsersRecurlyQty > 0
  // ) {
  //   setQuantity(keapAddUsersRecurlyQty)
  // }
  const findUnitAmount = (currencies, selectedCountry, _seatQty) => {
    const currency = currencies.find(
      currency =>
        currency.currency === CC_CURRENCIES[COUNTRIES[selectedCountry]?.value],
    )
    const unitAmount = currency?.unitAmount
    // const needFlag = currency?.needFlag  // returned but never consumed by any caller
    return {unitAmount}
  }

  const formatItem = (item, selectedCountry, iconName, groupTitle) => {
    const {unitAmount: amount} = findUnitAmount(
      item.currencies,
      selectedCountry,
      null,
    )
    const baseData = {
      code: item.code,
      name: item.name,
      id: item.id,
      prodType: item?.prod_type,
      quantity: 1,
      unitAmount: amount,
      amount: amount,
      img: iconName,
      groupTitle: groupTitle,
    }
    return baseData
  }

  const KEAP_FAMILY_CODES = useMemo(
    () =>
      (all5PlanPrices?.centers ?? [])
        .filter(
          center =>
            center.uigroup === 'Keap' &&
            center.productBillingType != 'Annual' &&
            center.code.startsWith('keap_'),
        )
        .map(center => center.code),
    [all5PlanPrices?.centers],
  )
  const KEAP_FAMILY_LEGACY_CODES = useMemo(
    () =>
      (all5PlanPrices?.centers ?? [])
        .filter(
          center =>
            center.uigroup === 'Hidden' &&
            center.productBillingType === 'Monthly' &&
            center.code.startsWith('keap_'),
        )
        .map(center => center.code),
    [all5PlanPrices?.centers],
  )
  const KEAP_FAMILY_ANNUAL_CODES = useMemo(
    () =>
      (all5PlanPrices?.centers ?? [])
        .filter(
          center =>
            center.uigroup === 'Keap' &&
            center.productBillingType === 'Annual' &&
            center.code.startsWith('keap_'),
        )
        .map(center => center.code),
    [all5PlanPrices?.centers],
  )
  const KEAP_FAMILY_LEGACY_ANNUAL_CODES = useMemo(
    () =>
      (all5PlanPrices?.centers ?? [])
        .filter(
          center =>
            center.uigroup === 'Hidden' &&
            center.productBillingType === 'Annual' &&
            center.code.startsWith('keap_'),
        )
        .map(center => center.code),
    [all5PlanPrices?.centers],
  )

  let ADDITIONAL_CONTACT_OPTIONS = []
  let KEAP_TEXT_VOICE_OPTIONS = []
  let KCP_OPTIONS = []
  let ADDITIONAL_CONTACT_OPTIONS_ANNUAL = []
  let KEAP_TEXT_VOICE_OPTIONS_ANNUAL = []
  let ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL = []
  let PLUS_THIS_PREMIUM_ANNUAL = []
  if (selectedCountry === 'US') {
    ADDITIONAL_CONTACT_OPTIONS = [
      {name: 'Up To 1,000 Contacts: $36', value: '1000-36'},
      {name: 'Up To 2,500 Contacts: $84', value: '2500-84'},
      {name: 'Up To 5,000 Contacts: $150', value: '5000-150'},
      {name: 'Up To 10,000 Contacts: $240', value: '10000-240'},
      {name: 'Up To 15,000 Contacts: $330', value: '15000-330'},
      {name: 'Up To 25,000 Contacts: $420', value: '25000-420'},
      {name: 'Up To 50,000 Contacts: $480', value: '50000-480'},
      {name: 'Up To 75,000 Contacts: $600', value: '75000-600'},
      {name: 'Up To 100,000 Contacts: $720', value: '100000-720'},
      {name: 'Up To 200,000 Contacts: $1,200', value: '200000-1200'},
      {name: 'Up To 500,000 Contacts: $1,980', value: '500000-1980'},
      {name: 'Up To 750,000 Contacts: $2,940', value: '750000-2940'},
      {name: 'Up To 1,000,000 Contacts: $3,720', value: '1000000-3720'},
      {name: 'Up To 2,000,000 Contacts: $5,940', value: '2000000-5940'},
      {name: 'Up To 3,000,000 Contacts: $7,200', value: '3000000-7200'},
      {name: 'Up To 4,000,000 Contacts: $8,460', value: '4000000-8460'},
      {name: 'Over 4,000,000 Contacts: $10,140', value: '5000000-10140'},
    ]
    KEAP_TEXT_VOICE_OPTIONS = [
      {name: 'Tier 2: $24', value: '2-24'},
      {name: 'Tier 3: $39', value: '3-39'},
      {name: 'Tier 4: $79', value: '4-79'},
      {name: 'Tier 5: $139', value: '5-139'},
      {name: 'Tier 6: $279', value: '6-279'},
    ]
    KCP_OPTIONS = [
      {name: '$1,500', value: '1500'},
      {name: '$750', value: '750'},
      {name: '$499', value: '499'},
      {name: '$299', value: '299'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $346', value: '1000-346'},
      {name: 'Up To 2,500 Contacts: $792', value: '2500-792'},
      {name: 'Up To 5,000 Contacts: $1,440', value: '5000-1440'},
      {name: 'Up To 10,000 Contacts: $2,304', value: '10000-2304'},
      {name: 'Up To 15,000 Contacts: $3,168', value: '15000-3168'},
      {name: 'Up To 25,000 Contacts: $4,032', value: '25000-4032'},
      {name: 'Up To 50,000 Contacts: $4,608', value: '50000-4608'},
      {name: 'Up To 75,000 Contacts: $5,760', value: '75000-5760'},
      {name: 'Up To 100,000 Contacts: $6,912', value: '100000-6912'},
      {name: 'Up To 200,000 Contacts: $11,520', value: '200000-11520'},
      {name: 'Up To 500,000 Contacts: $19,008', value: '500000-19008'},
      {name: 'Up To 750,000 Contacts: $28,224', value: '750000-28224'},
      {name: 'Up To 1,000,000 Contacts: $35,712', value: '1000000-35712'},
      {name: 'Up To 2,000,000 Contacts: $57,024', value: '2000000-57024'},
      {name: 'Up To 3,000,000 Contacts: $69,120', value: '3000000-69120'},
      {name: 'Up To 4,000,000 Contacts: $81,216', value: '4000000-81216'},
      {name: 'Over 4,000,000 Contacts: $97,344', value: '5000000-97344'},
    ]
    KEAP_TEXT_VOICE_OPTIONS_ANNUAL = [
      {name: 'Tier 2: $288', value: '2-288'},
      {name: 'Tier 3: $468', value: '3-468'},
      {name: 'Tier 4: $948', value: '4-948'},
      {name: 'Tier 5: $1,668', value: '5-1668'},
      {name: 'Tier 6: $3,348', value: '6-3348'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $102', value: '1000-102'},
      {name: 'Up To 2,500 Contacts: $153', value: '2500-153'},
      {name: 'Up To 5,000 Contacts: $204', value: '5000-204'},
      {name: 'Up To 10,000 Contacts: $306', value: '10000-306'},
      {name: 'Up To 25,000 Contacts: $510', value: '25000-510'},
      {name: 'Up To 50,000 Contacts: $816', value: '50000-816'},
      {name: 'Up To 75,000 Contacts: $1,020', value: '75000-1020'},
      {name: 'Up To 100,000 Contacts: $1,224', value: '100000-1224'},
      {name: 'Up To 200,000 Contacts: $1,663.62', value: '200000-1663.62'},
      {name: 'Up To 500,000 Contacts: $3,570', value: '500000-3570'},
      {name: 'Up To 750,000 Contacts: $5,100', value: '750000-5100'},
      {name: 'Up To 1,000,000 Contacts: $7,140', value: '1000000-7140'},
      {name: 'Up To 2,000,000 Contacts: $9,690', value: '2000000-9690'},
      {name: 'Up To 3,000,000 Contacts: $11,730', value: '3000000-11730'},
      {name: 'Up To 4,000,000 Contacts: $13,260', value: '4000000-13260'},
      {name: 'Over 4,000,000 Contacts: $14,280', value: '5000000-14280'},
    ]
    PLUS_THIS_PREMIUM_ANNUAL = [
      {name: 'Up To 200,000 Transactions: $2,388', value: '200000-2388'},
      {name: 'Up To 500,000 Transactions: $3,588', value: '500000-3588'},
      {name: 'Up To 1,000,000 Transactions: $5,988', value: '1000000-5988'},
      {name: 'Up To 2,000,000 Transactions: $8,388', value: '2000000-8388'},
    ]
  } else if (selectedCountry === 'CA') {
    ADDITIONAL_CONTACT_OPTIONS = [
      {name: 'Up To 1,000 Contacts: $49', value: '1000-49'},
      {name: 'Up To 2,500 Contacts: $114', value: '2500-114'},
      {name: 'Up To 5,000 Contacts: $203', value: '5000-203'},
      {name: 'Up To 10,000 Contacts: $325', value: '10000-325'},
      {name: 'Up To 15,000 Contacts: $446', value: '15000-446'},
      {name: 'Up To 25,000 Contacts: $569', value: '25000-569'},
      {name: 'Up To 50,000 Contacts: $649', value: '50000-649'},
      {name: 'Up To 75,000 Contacts: $811', value: '75000-811'},
      {name: 'Up To 100,000 Contacts: $973', value: '100000-973'},
      {name: 'Up To 200,000 Contacts: $1,622', value: '200000-1622'},
      {name: 'Up To 500,000 Contacts: $2,676', value: '500000-2676'},
      {name: 'Up To 750,000 Contacts: $3,973', value: '750000-3973'},
      {name: 'Up To 1,000,000 Contacts: $5,027', value: '1000000-5027'},
      {name: 'Up To 2,000,000 Contacts: $8,027', value: '2000000-8027'},
      {name: 'Up To 3,000,000 Contacts: $9,730', value: '3000000-9730'},
      {name: 'Up To 4,000,000 Contacts: $11,433', value: '4000000-11433'},
      {name: 'Over 4,000,000 Contacts: $13,703', value: '5000000-13703'},
    ]
    KEAP_TEXT_VOICE_OPTIONS = [
      {name: 'Tier 2: $32', value: '2-32'},
      {name: 'Tier 3: $53', value: '3-53'},
      {name: 'Tier 4: $107', value: '4-107'},
      {name: 'Tier 5: $188', value: '5-188'},
      {name: 'Tier 6: $377', value: '6-377'},
    ]
    KCP_OPTIONS = [
      {name: '$405', value: '405'},
      {name: '$700', value: '700'},
      {name: '$1,000', value: '1000'},
      {name: '$2,000', value: '2000'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $470', value: '1000-470'},
      {name: 'Up To 2,500 Contacts: $1,094', value: '2500-1094'},
      {name: 'Up To 5,000 Contacts: $1,949', value: '5000-1949'},
      {name: 'Up To 10,000 Contacts: $3,120', value: '10000-3120'},
      {name: 'Up To 15,000 Contacts: $4,282', value: '15000-4282'},
      {name: 'Up To 25,000 Contacts: $5,462', value: '25000-5462'},
      {name: 'Up To 50,000 Contacts: $6,230', value: '50000-6230'},
      {name: 'Up To 75,000 Contacts: $7,786', value: '75000-7786'},
      {name: 'Up To 100,000 Contacts: $9,341', value: '100000-9341'},
      {name: 'Up To 200,000 Contacts: $15,571', value: '200000-15571'},
      {name: 'Up To 500,000 Contacts: $25,690', value: '500000-25690'},
      {name: 'Up To 750,000 Contacts: $38,141', value: '750000-38141'},
      {name: 'Up To 1,000,000 Contacts: $48,259', value: '1000000-48259'},
      {name: 'Up To 2,000,000 Contacts: $77,059', value: '2000000-77059'},
      {name: 'Up To 3,000,000 Contacts: $93,408', value: '3000000-93408'},
      {name: 'Up To 4,000,000 Contacts: $109,757', value: '4000000-109757'},
      {name: 'Over 4,000,000 Contacts: $131,549', value: '5000000-131549'},
    ]
    KEAP_TEXT_VOICE_OPTIONS_ANNUAL = [
      {name: 'Tier 2: $384', value: '2-384'},
      {name: 'Tier 3: $636', value: '3-636'},
      {name: 'Tier 4: $1,284', value: '4-1284'},
      {name: 'Tier 5: $2,256', value: '5-2256'},
      {name: 'Tier 6: $4,524', value: '6-4524'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $142.80', value: '1000-142.80'},
      {name: 'Up To 2,500 Contacts: $204', value: '2500-204'},
      {name: 'Up To 5,000 Contacts: $285.50', value: '5000-285.60'},
      {name: 'Up To 10,000 Contacts: $418.20', value: '10000-418.20'},
      {name: 'Up To 25,000 Contacts: $714', value: '25000-714'},
      {name: 'Up To 50,000 Contacts: $1,122', value: '50000-1122'},
      {name: 'Up To 75,000 Contacts: $1,407', value: '75000-1407'},
      {name: 'Up To 100,000 Contacts: $1,693.20', value: '100000-1693.20'},
      {name: 'Up To 200,000 Contacts: $2,805', value: '200000-2805'},
      {name: 'Up To 500,000 Contacts: $4,926.40', value: '500000-4926.60'},
      {name: 'Up To 750,000 Contacts: $7,038', value: '750000-7038'},
      {name: 'Up To 1,000,000 Contacts: $9,863.40', value: '1000000-9863.40'},
      {name: 'Up To 2,000,000 Contacts: $13,382.40', value: '2000000-13382.40'},
      {name: 'Up To 3,000,000 Contacts: $16,197.60', value: '3000000-16197.60'},
      {name: 'Up To 4,000,000 Contacts: $18,309', value: '4000000-18309'},
      {name: 'Over 4,000,000 Contacts: $19,716', value: '5000000-19716'},
    ]
    PLUS_THIS_PREMIUM_ANNUAL = [
      {name: 'Up To 200,000 Transactions: $3,228', value: '200000-3288'},
      {name: 'Up To 500,000 Transactions: $4,860', value: '500000-4860'},
      {name: 'Up To 1,000,000 Transactions: $8,400', value: '1000000-8400'},
      {name: 'Up To 2,000,000 Transactions: $11,580', value: '2000000-11580'},
    ]
  } else if (selectedCountry === 'AU') {
    ADDITIONAL_CONTACT_OPTIONS = [
      {
        name: 'Up To 1,000 Contacts: AU $42.00',
        value: '1000-42.00',
      },
      {
        name: 'Up To 2,500 Contacts: AU $98.00',
        value: '2500-98.00',
      },
      {
        name: 'Up To 5,000 Contacts: AU $178.00',
        value: '5000-178.00',
      },
      {
        name: 'Up To 10,000 Contacts: AU $282.00',
        value: '10000-282.00',
      },
      {
        name: 'Up To 15,000 Contacts: AU $389.00',
        value: '15000-389.00',
      },
      {
        name: 'Up To 25,000 Contacts: AU $496.00',
        value: '25000-496.00',
      },
      {
        name: 'Up To 50,000 Contacts: AU $567.00',
        value: '50000-567.00',
      },
      {
        name: 'Up To 75,000 Contacts: AU $707.00',
        value: '75000-707.00',
      },
      {
        name: 'Up To 100,000 Contacts: AU $850.00',
        value: '100000-850.00',
      },
      {
        name: 'Up To 200,000 Contacts: AU $1,415.00',
        value: '200000-1415.00',
      },
      {
        name: 'Up To 500,000 Contacts: AU $1,865.00',
        value: '500000-1865.00',
      },
      {
        name: 'Up To 750,000 Contacts: AU $3,458.00',
        value: '750000-3458.00',
      },
      {
        name: 'Up To 1,000,000 Contacts: AU $4,376.00',
        value: '1000000-4376.00',
      },
      {
        name: 'Up To 2,000,000 Contacts: AU $6,989.00',
        value: '2000000-6989.00',
      },
      {
        name: 'Up To 3,000,000 Contacts: AU $8,471.00',
        value: '3000000-8471.00',
      },
      {
        name: 'Up To 4,000,000 Contacts: AU $9,953.00',
        value: '4000000-9953.00',
      },
      {
        name: 'Over 4,000,000 Contacts: AU $11,930.00',
        value: '5000000-11930.00',
      },
    ]
    KEAP_TEXT_VOICE_OPTIONS = [
      {
        name: 'Tier 2: AU $40.00',
        value: '2-40.00',
      },
      {
        name: 'Tier 3: AU $65.00',
        value: '3-65.00',
      },
      {
        name: 'Tier 4: AU $130.00',
        value: '4-130.00',
      },
      {name: 'Tier 5: AU $230.00', value: '5-230.00'},
      {
        name: 'Tier 6: AU $465.00',
        value: '6-465.00',
      },
    ]
    KCP_OPTIONS = [
      {name: '$418', value: '418'},
      {name: '$704', value: '704'},
      {name: '$1,001', value: '1001'},
      {name: '$2,002', value: '2002'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $432', value: '1000-432'},
      {name: 'Up To 2,500 Contacts: $972', value: '2500-972'},
      {name: 'Up To 5,000 Contacts: $1,775', value: '5000-1775'},
      {name: 'Up To 10,000 Contacts: $2,833', value: '10000-2833'},
      {name: 'Up To 15,000 Contacts: $3,900', value: '15000-3900'},
      {name: 'Up To 25,000 Contacts: $4,968', value: '25000-4968'},
      {name: 'Up To 50,000 Contacts: $5,676', value: '50000-5676'},
      {name: 'Up To 75,000 Contacts: $7,092', value: '75000-7092'},
      {name: 'Up To 100,000 Contacts: $8,507', value: '100000-8507'},
      {name: 'Up To 200,000 Contacts: $14,185', value: '200000-14185'},
      {name: 'Up To 500,000 Contacts: $23,400', value: '500000-23400'},
      {name: 'Up To 750,000 Contacts: $34,740', value: '750000-34740'},
      {name: 'Up To 1,000,000 Contacts: $43,956', value: '1000000-43956'},
      {name: 'Up To 2,000,000 Contacts: $70,188', value: '2000000-70188'},
      {name: 'Up To 3,000,000 Contacts: $85,067', value: '3000000-85067'},
      {name: 'Up To 4,000,000 Contacts: $99,960', value: '4000000-99960'},
      {name: 'Over 4,000,000 Contacts: $119,808', value: '5000000-119808'},
    ]
    KEAP_TEXT_VOICE_OPTIONS_ANNUAL = [
      {name: 'Tier 2: $480', value: '2-480'},
      {name: 'Tier 3: $780', value: '3-780'},
      {name: 'Tier 4: $1,560', value: '4-1560'},
      {name: 'Tier 5: $2,760', value: '5-2760'},
      {name: 'Tier 6: $5,580', value: '6-5580'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $165.30', value: '1000-165.30'},
      {name: 'Up To 2,500 Contacts: $247.95', value: '2500-247.95'},
      {name: 'Up To 5,000 Contacts: $330.61', value: '5000-330.61'},
      {name: 'Up To 10,000 Contacts: $495.90', value: '10000-495.90'},
      {name: 'Up To 25,000 Contacts: $826.52', value: '25000-826.52'},
      {name: 'Up To 50,000 Contacts: $1,322.43', value: '50000-1322.43'},
      {name: 'Up To 75,000 Contacts: $1,653.04', value: '75000-1653.04'},
      {name: 'Up To 100,000 Contacts: $1,983.64', value: '100000-1983.64'},
      {name: 'Up To 200,000 Contacts: $3,306.08', value: '200000-3306.08'},
      {name: 'Up To 500,000 Contacts: $5,785.65', value: '500000-5785.65'},
      {name: 'Up To 750,000 Contacts: $8,265.21', value: '750000-8265.21'},
      {name: 'Up To 1,000,000 Contacts: $11,571.30', value: '1000000-11571.30'},
      {name: 'Up To 2,000,000 Contacts: $15,703.90', value: '2000000-15703.90'},
      {name: 'Up To 3,000,000 Contacts: $19,009.98', value: '3000000-19009.98'},
      {name: 'Up To 4,000,000 Contacts: $21,489.55', value: '4000000-21489.55'},
      {name: 'Over 4,000,000 Contacts: $23,142.59', value: '5000000-23142.59'},
    ]
    PLUS_THIS_PREMIUM_ANNUAL = [
      {name: 'Up To 200,000 Transactions: $3,876', value: '200000-3876'},
      {name: 'Up To 500,000 Transactions: $5,016', value: '500000-5016'},
      {name: 'Up To 1,000,000 Transactions: $8,400', value: '1000000-8400'},
      {name: 'Up To 2,000,000 Transactions: $11,760', value: '2000000-11760'},
    ]
  } else if (selectedCountry === 'NZ') {
    ADDITIONAL_CONTACT_OPTIONS = [
      {name: 'Up To 1,000 Contacts: $46.00', value: '1000-46.00'},
      {name: 'Up To 2,500 Contacts: $108.00', value: '2500-108.00'},
      {name: 'Up To 5,000 Contacts: $196.00', value: '5000-196.00'},
      {name: 'Up To 10,000 Contacts: $310.00', value: '10000-310.00'},
      {name: 'Up To 15,000 Contacts: $428.00', value: '15000-428.00'},
      {name: 'Up To 25,000 Contacts: $568.00', value: '25000-568.00'},
      {name: 'Up To 50,000 Contacts: $624.00', value: '50000-624.00'},
      {name: 'Up To 75,000 Contacts: $778.00', value: '75000-778.00'},
      {name: 'Up To 100,000 Contacts: $935.00', value: '100000-935.00'},
      {name: 'Up To 200,000 Contacts: $1,557.00', value: '200000-1557.00'},
      {name: 'Up To 500,000 Contacts: $2,052.00', value: '500000-2052.00'},
      {name: 'Up To 750,000 Contacts: $3,804.00', value: '750000-3804.00'},
      {name: 'Up To 1,000,000 Contacts: $4,814.00', value: '1000000-4814.00'},
      {name: 'Up To 2,000,000 Contacts: $7,689.00', value: '2000000-7689.00'},
      {name: 'Up To 3,000,000 Contacts: $9,319.00', value: '3000000-9319.00'},
      {name: 'Up To 4,000,000 Contacts: $10,949.00', value: '4000000-10949.00'},
      {name: 'Over 4,000,000 Contacts: $13,124.00', value: '5000000-13124.00'},
    ]
    KEAP_TEXT_VOICE_OPTIONS = [
      {name: 'Tier 2: $40.00', value: '2-40.00'},
      {name: 'Tier 3: $65.00', value: '3-65.00'},
      {name: 'Tier 4: $132.00', value: '4-132.00'},
      {name: 'Tier 5: $232.00', value: '5-232.00'},
      {name: 'Tier 6: $465.00', value: '6-465.00'},
    ]
    KCP_OPTIONS = [
      {name: '$462', value: '462'},
      {name: '$770', value: '770'},
      {name: '$1,100', value: '1100'},
      {name: '$2,200', value: '2200'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $442', value: '1000-442'},
      {name: 'Up To 2,500 Contacts: $1,037', value: '2500-1037'},
      {name: 'Up To 5,000 Contacts: $1,882', value: '5000-1882'},
      {name: 'Up To 10,000 Contacts: $2,976', value: '10000-2976'},
      {name: 'Up To 15,000 Contacts: $4,109', value: '15000-4109'},
      {name: 'Up To 25,000 Contacts: $5,453', value: '25000-5453'},
      {name: 'Up To 50,000 Contacts: $5,990', value: '50000-5990'},
      {name: 'Up To 75,000 Contacts: $7,469', value: '75000-7469'},
      {name: 'Up To 100,000 Contacts: $8,976', value: '100000-8976'},
      {name: 'Up To 200,000 Contacts: $14,947', value: '200000-14947'},
      {name: 'Up To 500,000 Contacts: $19,699', value: '500000-19699'},
      {name: 'Up To 750,000 Contacts: $36,518', value: '750000-36518'},
      {name: 'Up To 1,000,000 Contacts: $46,214', value: '1000000-46214'},
      {name: 'Up To 2,000,000 Contacts: $73,814', value: '2000000-73814'},
      {name: 'Up To 3,000,000 Contacts: $89,462', value: '3000000-89462'},
      {name: 'Up To 4,000,000 Contacts: $105,110', value: '4000000-105110'},
      {name: 'Over 4,000,000 Contacts: $125,990', value: '5000000-125990'},
    ]
    KEAP_TEXT_VOICE_OPTIONS_ANNUAL = [
      {name: 'Tier 2: $288', value: '2-288'},
      {name: 'Tier 3: $468', value: '3-468'},
      {name: 'Tier 4: $948', value: '4-948'},
      {name: 'Tier 5: $1,668', value: '5-1668'},
      {name: 'Tier 6: $3,348', value: '6-3348'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL = [
      {name: 'Up To 1,000 Contacts: $165.27', value: '1000-165.27'},
      {name: 'Up To 2,500 Contacts: $247.85', value: '2500-247.85'},
      {name: 'Up To 5,000 Contacts: $330.54', value: '5000-330.54'},
      {name: 'Up To 10,000 Contacts: $495.81', value: '10000-495.81'},
      {name: 'Up To 25,000 Contacts: $826.47', value: '25000-826.47'},
      {name: 'Up To 50,000 Contacts: $1,322.39', value: '50000-1322.39'},
      {name: 'Up To 75,000 Contacts: $1,653.04', value: '75000-1653.04'},
      {name: 'Up To 100,000 Contacts: $1,983.58', value: '100000-1983.58'},
      {name: 'Up To 200,000 Contacts: $3,306.09', value: '200000-3306.09'},
      {name: 'Up To 500,000 Contacts: $5,785.59', value: '500000-5785.59'},
      {name: 'Up To 750,000 Contacts: $8,265.21', value: '750000-8265.21'},
      {name: 'Up To 1,000,000 Contacts: $11,571.30', value: '1000000-11571.30'},
      {name: 'Up To 2,000,000 Contacts: $15,703.85', value: '2000000-15703.85'},
      {name: 'Up To 3,000,000 Contacts: $19,009.93', value: '3000000-19009.93'},
      {name: 'Up To 4,000,000 Contacts: $21,489.55', value: '4000000-21489.55'},
      {name: 'Over 4,000,000 Contacts: $23,142.82', value: '5000000-23142.82'},
    ]
    PLUS_THIS_PREMIUM_ANNUAL = [
      {name: 'Up To 200,000 Transactions: $3,894', value: '200000-3894'},
      {name: 'Up To 500,000 Transactions: $5,544', value: '500000-5544'},
      {name: 'Up To 1,000,000 Transactions: $9,240', value: '1000000-9240'},
      {name: 'Up To 2,000,000 Transactions: $12,936', value: '2000000-12936'},
    ]
  } else if (selectedCountry === 'GB') {
    ADDITIONAL_CONTACT_OPTIONS = [
      {name: 'Up To 1,000 Contacts: £29.00', value: '1000-29.00'},
      {name: 'Up To 2,500 Contacts: £68.00', value: '2500-68.00'},
      {name: 'Up To 5,000 Contacts: £122.00', value: '5000-122.00'},
      {name: 'Up To 10,000 Contacts: £196.00', value: '10000-196.00'},
      {name: 'Up To 15,000 Contacts: £269.00', value: '15000-269.00'},
      {name: 'Up To 25,000 Contacts: £342.00', value: '25000-342.00'},
      {name: 'Up To 50,000 Contacts: £390.00', value: '50000-390.00'},
      {name: 'Up To 75,000 Contacts: £488.00', value: '75000-488.00'},
      {name: 'Up To 100,000 Contacts: £586.00', value: '100000-586.00'},
      {name: 'Up To 200,000 Contacts: £976.00', value: '200000-976.00'},
      {name: 'Up To 500,000 Contacts: £1,609.00', value: '500000-1609.00'},
      {name: 'Up To 750,000 Contacts: £2,390.00', value: '750000-2390.00'},
      {name: 'Up To 1,000,000 Contacts: £3,024.00', value: '1000000-3024.00'},
      {name: 'Up To 2,000,000 Contacts: £4,829.00', value: '2000000-4829.00'},
      {name: 'Up To 3,000,000 Contacts: £5,854.00', value: '3000000-5854.00'},
      {name: 'Up To 4,000,000 Contacts: £6,878.00', value: '4000000-6878.00'},
      {name: 'Over 4,000,000 Contacts: £8,244.00', value: '5000000-8244.00'},
    ]
    KEAP_TEXT_VOICE_OPTIONS = [
      {name: 'Tier 2: £19.00', value: '2-19.00'},
      {name: 'Tier 3: £31.00', value: '3-31.00'},
      {name: 'Tier 4: £62.00', value: '4-62.00'},
      {name: 'Tier 5: £108.00', value: '5-108.00'},
      {name: 'Tier 6: £219.00', value: '6-219.00'},
    ]
    KCP_OPTIONS = [
      {name: '£223', value: '223'},
      {name: '£372', value: '372'},
      {name: '£559', value: '559'},
      {name: '£1116', value: '1116'},
    ]
    KEAP_TEXT_VOICE_OPTIONS_ANNUAL = [
      {name: 'Tier 2: £228', value: '2-228'},
      {name: 'Tier 3: £372', value: '3-372'},
      {name: 'Tier 4: £744', value: '4-744'},
      {name: 'Tier 5: £1,296', value: '5-1296'},
      {name: 'Tier 6: £2,628', value: '6-2628'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_ANNUAL = [
      {name: 'Up To 1,000 Contacts: £278', value: '1000-278'},
      {name: 'Up To 2,500 Contacts: £653', value: '2500-653'},
      {name: 'Up To 5,000 Contacts: £1,171', value: '5000-1171'},
      {name: 'Up To 10,000 Contacts: £1,872', value: '10000-1872'},
      {name: 'Up To 15,000 Contacts: £2,582', value: '25000-2582'},
      {name: 'Up To 25,000 Contacts: £3,283', value: '50000-3283'},
      {name: 'Up To 50,000 Contacts: £3,744', value: '75000-3744'},
      {name: 'Up To 75,000 Contacts: £4,685', value: '100000-4685'},
      {name: 'Up To 100,000 Contacts: £5,626', value: '200000-5626'},
      {name: 'Up To 200,000 Contacts: £9,370', value: '500000-9370'},
      {name: 'Up To 500,000 Contacts: £15,446', value: '750000-15446'},
      {name: 'Up To 750,000 Contacts: £22,944', value: '1000000-22944'},
      {name: 'Up To 1,000,000 Contacts: £29,030', value: '2000000-29030'},
      {name: 'Up To 2,000,000 Contacts: £46,358', value: '3000000-46358'},
      {name: 'Up To 3,000,000 Contacts: £56,198', value: '4000000-56198'},
      {name: 'Up To 4,000,000 Contacts: £66,029', value: '4000000-66029'},
      {name: 'Over 4,000,000 Contacts: £79,142', value: '5000000-79142'},
    ]
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL = [
      {name: 'Up To 1,000 Contacts: £83.18', value: '1000-83.18'},
      {name: 'Up To 2,500 Contacts: £124.77', value: '2500-124.77'},
      {name: 'Up To 5,000 Contacts: £166.36', value: '5000-166.36'},
      {name: 'Up To 10,000 Contacts: £249.54', value: '10000-249.54'},
      {name: 'Up To 25,000 Contacts: £415.90', value: '25000-415.90'},
      {name: 'Up To 50,000 Contacts: £665.44', value: '50000-665.44'},
      {name: 'Up To 75,000 Contacts: £831.81', value: '75000-831.81'},
      {name: 'Up To 100,000 Contacts: £998.17', value: '100000-998.17'},
      {name: 'Up To 200,000 Contacts: £2,040', value: '200000-2040'},
      {name: 'Up To 500,000 Contacts: £2,911.33', value: '500000-2911.33'},
      {name: 'Up To 750,000 Contacts: £4,159.05', value: '750000-4159.05'},
      {name: 'Up To 1,000,000 Contacts: £5,822.67', value: '1000000-5822.67'},
      {name: 'Up To 2,000,000 Contacts: £7,902.19', value: '2000000-7902.19'},
      {name: 'Up To 3,000,000 Contacts: £9,566.81', value: '3000000-9566.81'},
      {name: 'Up To 4,000,000 Contacts: £10,813.53', value: '4000000-10813.53'},
      {name: 'Over 4,000,000 Contacts: £11,645.34', value: '5000000-11645.34'},
    ]
    PLUS_THIS_PREMIUM_ANNUAL = [
      {name: 'Up To 200,000 Transactions: £1,620', value: '200000-1620'},
      {name: 'Up To 500,000 Transactions: £2,676', value: '500000-2676'},
      {name: 'Up To 1,000,000 Transactions: £4,464', value: '1000000-4464'},
      {name: 'Up To 2,000,000 Transactions: £6,240', value: '2000000-6240'},
    ]
  }

  let ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_M2M =
    selectedCountry === 'US'
      ? [
          {name: 'Up To 1,000 Contacts: $10', value: '1000-10'},
          {name: 'Up To 2,500 Contacts: $15', value: '2500-15'},
          {name: 'Up To 5,000 Contacts: $20', value: '5000-20'},
          {name: 'Up To 10,000 Contacts: $30', value: '10000-30'},
          {name: 'Up To 25,000 Contacts: $50', value: '25000-50'},
          {name: 'Up To 50,000 Contacts: $80', value: '50000-80'},
          {name: 'Up To 75,000 Contacts: $100', value: '75000-100'},
          {name: 'Up To 100,000 Contacts: $120', value: '100000-120'},
          {name: 'Up To 200,000 Contacts: $200', value: '200000-200'},
          {name: 'Up To 500,000 Contacts: $350', value: '500000-350'},
          {name: 'Up To 750,000 Contacts: $500', value: '750000-500'},
          {name: 'Up To 1,000,000 Contacts: $700', value: '1000000-700'},
          {name: 'Up To 2,000,000 Contacts: $950', value: '2000000-950'},
          {name: 'Up To 3,000,000 Contacts: $1,150', value: '3000000-1150'},
          {name: 'Up To 4,000,000 Contacts: $1,300', value: '4000000-1300'},
          {name: 'Over 4,000,000 Contacts: $1,400', value: '5000000-1400'},
        ]
      : selectedCountry === 'CA'
      ? [
          {name: 'Up To 1,000 Contacts: $14', value: '1000-14'},
          {name: 'Up To 2,500 Contacts: $20', value: '2500-20'},
          {name: 'Up To 5,000 Contacts: $28', value: '5000-28'},
          {name: 'Up To 10,000 Contacts: $41', value: '10000-41'},
          {name: 'Up To 25,000 Contacts: $70', value: '25000-70'},
          {name: 'Up To 50,000 Contacts: $110', value: '50000-110'},
          {name: 'Up To 75,000 Contacts: $138', value: '75000-138'},
          {name: 'Up To 100,000 Contacts: $166', value: '100000-166'},
          {name: 'Up To 200,000 Contacts: $275', value: '200000-275'},
          {name: 'Up To 500,000 Contacts: $483', value: '500000-483'},
          {name: 'Up To 750,000 Contacts: $690', value: '750000-690'},
          {name: 'Up To 1,000,000 Contacts: $967', value: '1000000-967'},
          {name: 'Up To 2,000,000 Contacts: $1,312', value: '2000000-1312'},
          {name: 'Up To 3,000,000 Contacts: $1,588', value: '3000000-1588'},
          {name: 'Up To 4,000,000 Contacts: $1,795', value: '4000000-1795'},
          {name: 'Over 4,000,000 Contacts: $1,933', value: '5000000-1933'},
        ]
      : selectedCountry === 'AU'
      ? [
          {name: 'Up To 1,000 Contacts: $16.20', value: '1000-16.20'},
          {name: 'Up To 2,500 Contacts: $24.30', value: '2500-24.30'},
          {name: 'Up To 5,000 Contacts: $32.41', value: '5000-32.41'},
          {name: 'Up To 10,000 Contacts: $48.61', value: '10000-48.61'},
          {name: 'Up To 25,000 Contacts: $81.03', value: '25000-81.03'},
          {name: 'Up To 50,000 Contacts: $129.65', value: '50000-129.65'},
          {name: 'Up To 75,000 Contacts: $162.06', value: '75000-162.06'},
          {name: 'Up To 100,000 Contacts: $194.47', value: '100000-194.47'},
          {name: 'Up To 200,000 Contacts: $324.13', value: '200000-324.13'},
          {name: 'Up To 500,000 Contacts: $567.21', value: '500000-567.21'},
          {name: 'Up To 750,000 Contacts: $810.32', value: '750000-810.32'},
          {
            name: 'Up To 1,000,000 Contacts: $1,134.44',
            value: '1000000-1134.44',
          },
          {
            name: 'Up To 2,000,000 Contacts: $1,539.59',
            value: '2000000-1539.59',
          },
          {
            name: 'Up To 3,000,000 Contacts: $1,863.72',
            value: '3000000-1863.72',
          },
          {
            name: 'Up To 4,000,000 Contacts: $2,106.82',
            value: '4000000-2106.82',
          },
          {
            name: 'Over 4,000,000 Contacts: $2,269.98',
            value: '5000000-2269.98',
          },
        ]
      : selectedCountry === 'NZ'
      ? [
          {name: 'Up To 1,000 Contacts: $16.20', value: '1000-16.20'},
          {name: 'Up To 2,500 Contacts: $24.30', value: '2500-24.30'},
          {name: 'Up To 5,000 Contacts: $32.41', value: '5000-32.41'},
          {name: 'Up To 10,000 Contacts: $48.61', value: '10000-48.61'},
          {name: 'Up To 25,000 Contacts: $81.03', value: '25000-81.03'},
          {name: 'Up To 50,000 Contacts: $129.65', value: '50000-129.65'},
          {name: 'Up To 75,000 Contacts: $162.06', value: '75000-162.06'},
          {name: 'Up To 100,000 Contacts: $194.47', value: '100000-194.47'},
          {name: 'Up To 200,000 Contacts: $324.13', value: '200000-324.13'},
          {name: 'Up To 500,000 Contacts: $567.22', value: '500000-567.22'},
          {name: 'Up To 750,000 Contacts: $810.32', value: '750000-810.32'},
          {
            name: 'Up To 1,000,000 Contacts: $1,134.44',
            value: '1000000-1134.44',
          },
          {
            name: 'Up To 2,000,000 Contacts: $1,539.59',
            value: '2000000-1539.59',
          },
          {
            name: 'Up To 3,000,000 Contacts: $1,863.72',
            value: '3000000-1863.72',
          },
          {
            name: 'Up To 4,000,000 Contacts: $2,106.82',
            value: '4000000-2106.82',
          },
          {
            name: 'Over 4,000,000 Contacts: $2,269.98',
            value: '5000000-2269.98',
          },
        ]
      : [
          {name: 'Up To 1,000 Contacts: £8.15', value: '1000-8.15'},
          {name: 'Up To 2,500 Contacts: £12.23', value: '2500-12.23'},
          {name: 'Up To 5,000 Contacts: £16.31', value: '5000-16.31'},
          {name: 'Up To 10,000 Contacts: £24.46', value: '10000-24.46'},
          {name: 'Up To 25,000 Contacts: £40.77', value: '25000-40.77'},
          {name: 'Up To 50,000 Contacts: £65.24', value: '50000-65.24'},
          {name: 'Up To 75,000 Contacts: £81.55', value: '75000-81.55'},
          {name: 'Up To 100,000 Contacts: £97.86', value: '100000-97.86'},
          {name: 'Up To 200,000 Contacts: £163.10', value: '200000-163.10'},
          {name: 'Up To 500,000 Contacts: £285.42', value: '500000-285.42'},
          {name: 'Up To 750,000 Contacts: £407.75', value: '750000-407.75'},
          {name: 'Up To 1,000,000 Contacts: £570.85', value: '1000000-570.85'},
          {name: 'Up To 2,000,000 Contacts: £774.72', value: '2000000-774.72'},
          {name: 'Up To 3,000,000 Contacts: £937.82', value: '3000000-937.82'},
          {
            name: 'Up To 4,000,000 Contacts: £1,060.15',
            value: '4000000-1060.15',
          },
          {
            name: 'Over 4,000,000 Contacts: £1,141.70',
            value: '5000000-1141.70',
          },
        ]

  let PLUS_THIS_PREMIUM_M2M =
    selectedCountry === 'US'
      ? [
          {name: 'Up To 200,000 Transactions: $199', value: '200000-199'},
          {name: 'Up To 500,000 Transactions: $299', value: '500000-299'},
          {name: 'Up To 1,000,000 Transactions: $499', value: '1000000-499'},
          {name: 'Up To 2,000,000 Transactions: $699', value: '2000000-699'},
        ]
      : selectedCountry === 'CA'
      ? [
          {name: 'Up To 200,000 Transactions: $269', value: '200000-269'},
          {name: 'Up To 500,000 Transactions: $405', value: '500000-405'},
          {name: 'Up To 1,000,000 Transactions: $700', value: '1000000-700'},
          {name: 'Up To 2,000,000 Transactions: $965', value: '2000000-965'},
        ]
      : selectedCountry === 'AU'
      ? [
          {name: 'Up To 200,000 Transactions: $323', value: '200000-323'},
          {name: 'Up To 500,000 Transactions: $418', value: '500000-418'},
          {name: 'Up To 1,000,000 Transactions: $700', value: '1000000-700'},
          {name: 'Up To 2,000,000 Transactions: $980', value: '2000000-980'},
        ]
      : selectedCountry === 'NZ'
      ? [
          {name: 'Up To 200,000 Transactions: $332', value: '200000-332'},
          {name: 'Up To 500,000 Transactions: $462', value: '500000-462'},
          {name: 'Up To 1,000,000 Transactions: $770', value: '1000000-770'},
          {name: 'Up To 2,000,000 Transactions: $1,078', value: '2000000-1078'},
        ]
      : [
          {name: 'Up To 200,000 Transactions: £135', value: '200000-135'},
          {name: 'Up To 500,000 Transactions: £223', value: '500000-223'},
          {name: 'Up To 1,000,000 Transactions: £372', value: '1000000-372'},
          {name: 'Up To 2,000,000 Transactions: £520', value: '2000000-520'},
        ]

  if (kcpRecurlyOption) {
    KCP_OPTIONS = KCP_OPTIONS.filter(
      option => Number(option.value) >= Number(kcpRecurlyOption),
    )
  }

  if (keapAddContactsRecurlyQty) {
    ADDITIONAL_CONTACT_OPTIONS = ADDITIONAL_CONTACT_OPTIONS.filter(
      option =>
        Number(option.value.split('-')[0]) >= Number(keapAddContactsRecurlyQty),
    )
  }

  if (keapTextVoiceRecurlyQty) {
    KEAP_TEXT_VOICE_OPTIONS = KEAP_TEXT_VOICE_OPTIONS.filter(
      option =>
        Number(option.value.split('-')[0]) >= Number(keapTextVoiceRecurlyQty),
    )
  }

  if (keapTextVoiceRecurlyQtyAnnual) {
    KEAP_TEXT_VOICE_OPTIONS_ANNUAL = KEAP_TEXT_VOICE_OPTIONS_ANNUAL.filter(
      option =>
        Number(option.value.split('-')[0]) >=
        Number(keapTextVoiceRecurlyQtyAnnual),
    )
  }

  if (keapAddContactsRecurlyQtyAnnual) {
    ADDITIONAL_CONTACT_OPTIONS_ANNUAL =
      ADDITIONAL_CONTACT_OPTIONS_ANNUAL.filter(
        option =>
          Number(option.value.split('-')[0]) >=
          Number(keapAddContactsRecurlyQtyAnnual),
      )
    // setKeapAddContactsQtyAnnual(keapAddContactsRecurlyQtyAnnual)
  }

  if (plusThisPremiumRecurlyQtyAnnual) {
    PLUS_THIS_PREMIUM_ANNUAL = PLUS_THIS_PREMIUM_ANNUAL.filter(
      option =>
        Number(option.value.split('-')[0]) >=
        Number(plusThisPremiumRecurlyQtyAnnual),
    )
    // setPlusThisPremiumQtyGraphlyAnnual(plusThisPremiumRecurlyQtyAnnual)
  }

  if (keapAddContactsRecurlyQtyGraphlyAnnual) {
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL =
      ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL.filter(
        option =>
          Number(option.value.split('-')[0]) >=
          Number(keapAddContactsRecurlyQtyGraphlyAnnual),
      )
    // setKeapAddContactsQtyGraphlyAnnual(keapAddContactsRecurlyQtyGraphlyAnnual)
  }

  if (plusThisPremiumRecurlyQtyM2m) {
    PLUS_THIS_PREMIUM_M2M = PLUS_THIS_PREMIUM_M2M.filter(
      option =>
        Number(option.value.split('-')[0]) >=
        Number(plusThisPremiumRecurlyQtyM2m),
    )
  }

  if (keapAddContactsRecurlyQtyGraphlyM2m) {
    ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_M2M =
      ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_M2M.filter(
        option =>
          Number(option.value.split('-')[0]) >=
          Number(keapAddContactsRecurlyQtyGraphlyM2m),
      )
  }

  console.log('defaultCentersAndApps :: ', defaultCentersAndApps)
  const isHomeServices = [
    'maxhvac-5-thryv-m2m',
    'maxroof-5-thryv-m2m',
    'maxelect-5-thryv-m2m',
    'maxplumb-5-thryv-m2m',
  ].includes(selectedPlan?.code)
  const isPaidMCTrial = MC_2_0_PLANS.includes(selectedPlan?.code)
  const isMCTrialOnboardingRequired = MC_2_0_SIGNATUREPLANS.includes(
    selectedPlan?.code,
  )
  const isMCTrialOnboardingFeeRequired = MC_2_0_PREMIERPLANS.includes(
    selectedPlan?.code,
  )
  // FULSAS-12295: "Include Onboarding?" toggle lives on the Growth Package
  // add-on itself, but only shows when a Thryv Starter plan is in the order
  // and no Growth Package has already been added to the cart.
  const isGrowthPackagePlan = GROWTH_PACKAGES.includes(selectedPlan?.code)
  const isThryvStarterInCart = selectedCentersAndApps?.centers?.some(({code}) =>
    THRYV_STARTER_CODES.includes(code),
  )
  const isGrowthPackageAlreadyInCart = selectedCentersAndApps?.apps?.some(
    ({code}) => GROWTH_PACKAGES.includes(code),
  )
  const showIncludeOnboardingToggle =
    isGrowthPackagePlan && isThryvStarterInCart && !isGrowthPackageAlreadyInCart
  const isBCAlreadyPresent = defaultCentersAndApps?.centers?.filter(center =>
    center.name.toLowerCase().includes('business'),
  )
  const isMCAlreadyPresent = defaultCentersAndApps?.centers?.filter(center =>
    center.name.toLowerCase().includes('marketing'),
  )
  const isRCAlreadyPresent = defaultCentersAndApps?.centers?.filter(center =>
    center.name.toLowerCase().includes('reporting'),
  )
  const [socialAdsQuantity, setSocialAdsQuantity] = useState(1)
  const [aiWebsiteBuilderQuantity, setAiWebsiteBuilderQuantity] = useState(1)
  const [ctnQuantity, setCtnQuantity] = useState(1)
  const existingCtnQty = (() => {
    const existing = defaultCentersAndApps?.apps?.find(
      ({code, alreadyIncluded}) =>
        (code === 'addon-ctn-bninat-m2m' ||
          code === 'addon-ctn-bninat-annual') &&
        alreadyIncluded,
    )
    return existing?.quantity || 1
  })()
  // FULSAS-13425: floor the Geo Add-On (Local Select) slider at whatever
  // quantity is already owned, so it can only go up, never down.
  const existingGeoQty = (() => {
    if (!isGeoExpansionPlan(selectedPlan?.name)) return 0
    const existing = defaultCentersAndApps?.apps?.find(
      ({code, alreadyIncluded}) =>
        code === selectedPlan?.code && alreadyIncluded,
    )
    return existing?.quantity || 0
  })()
  const [isContinueDisableLogo, setIsContinueDisableLogo] = useState(false)
  const [isContinueDisableTMaxAddons, setIsContinueDisableTMaxAddons] =
    useState(false)
  const [isContinueDisableKccAnnual, setIsContinueDisableKccAnnual] =
    useState(false)
  const [planPrice, setPlanPrice] = useState('$0.00')
  const [keapAdditionalContactsPrice, setKeapAdditionalContactsPrice] =
    useState(0)
  const [
    keapAdditionalContactsPriceAnnual,
    setKeapAdditionalContactsPriceAnnual,
  ] = useState(0)
  const [
    keapAdditionalContactsPriceGraphlyAnnual,
    setKeapAdditionalContactsPriceGraphlyAnnual,
  ] = useState(0)
  const [PlusThisPremiumPriceAnnual, setPlusThisPremiumPriceAnnual] =
    useState(0)
  const [
    keapAdditionalContactsPriceGraphlyM2m,
    setKeapAdditionalContactsPriceGraphlyM2m,
  ] = useState(0)
  const [PlusThisPremiumPriceM2m, setPlusThisPremiumPriceM2m] = useState(0)
  const [keapTextVoicePrice, setKeapTextVoicePrice] = useState(0)
  const [keapTextVoicePriceAnnual, setKeapTextVoicePriceAnnual] = useState(0)
  const [validExtensionList, setValidExtensionList] = useState(VALID_TLDS)
  console.log('keapAdditionalContactsPrice :: ', keapAdditionalContactsPrice)
  console.log('keapTextVoicePrice :: ', keapTextVoicePrice)
  console.log('keapTextVoicePriceAnnual :: ', keapTextVoicePriceAnnual)
  console.log(
    'keapAdditionalContactsPriceGraphlyAnnual :: ',
    keapAdditionalContactsPriceGraphlyAnnual,
  )
  console.log('PlusThisPremiumPriceAnnual :: ', PlusThisPremiumPriceAnnual)
  console.log(
    'keapAdditionalContactsPriceGraphlyM2m :: ',
    keapAdditionalContactsPriceGraphlyM2m,
  )
  console.log('PlusThisPremiumPriceM2m :: ', PlusThisPremiumPriceM2m)

  useEffect(async () => {
    // fetch valid extension list
    let response = await client(
      'keappartner/fetchConfigLookupValue/ValidUrlExtension',
    )
    let extentionList = VALID_TLDS
    if (response?.data[0]?.value) {
      extentionList = response?.data[0]?.value.split(',')
    }
    setValidExtensionList(extentionList)
  }, [])

  // Auto-select required entitlements when plan is selected
  // useEffect(() => {
  //   if (selectedPlan?.entitlements) {
  //     const requiredEnts = selectedPlan.entitlements.filter(
  //       ent => ent.isRequired,
  //     )
  //     requiredEnts.forEach(requiredEnt => {
  //       const isAlreadySelected = selectedOptions.some(
  //         opt => opt.code === requiredEnt.code,
  //       )
  //       if (!isAlreadySelected) {
  //         setSelectedOptions(prev => [...prev, requiredEnt])
  //       }
  //     })
  //   }
  // }, [selectedPlan?.code])

  const isNewSEO = selectedPlan?.code === NEW_SEO_CODE
  const isSEO = selectedPlan?.name.toLowerCase().includes('seo') && !isNewSEO
  // console.log(selectedCentersAndApps)
  useEffect(() => {
    if (!isUpgradeFlow || selectedPlan?.code !== 'seobase-5-thryv-m2m') return
    if (!(Number(alphaSEOFromRecurly?.alphaProposalId) > 0)) return

    if (!alphaProposalId)
      setAlphaProposalId(alphaSEOFromRecurly.alphaProposalId)
    if (!alphaDomain) setAlphaDomain(alphaSEOFromRecurly.alphaDomain)
    if (alphaAmount === null || alphaAmount === undefined) {
      setAlphaAmount(alphaSEOFromRecurly.alphaAmount)
    }
    if (
      (isExternalDomain === null || isExternalDomain === undefined) &&
      alphaSEOFromRecurly.alphaIsExternalDomain
    ) {
      setIsExternalDomain(alphaSEOFromRecurly.alphaIsExternalDomain)
    }
    if (!futureBillingDate && alphaSEOFromRecurly.alphaStartDate) {
      setFutureBillingDate(alphaSEOFromRecurly.alphaStartDate)
    }
    if (alphaKeyCount === null || alphaKeyCount === undefined) {
      setAlphaKeyCount(alphaSEOFromRecurly.alphaKeyCount)
    }
    if (alphaPowerboostCount === null || alphaPowerboostCount === undefined) {
      setAlphaPowerboostCount(alphaSEOFromRecurly.alphaPowerboostCount)
    }
  }, [
    isUpgradeFlow,
    selectedPlan?.code,
    alphaSEOFromRecurly,
    alphaProposalId,
    alphaDomain,
    alphaAmount,
    isExternalDomain,
    futureBillingDate,
    alphaKeyCount,
    alphaPowerboostCount,
    setAlphaProposalId,
    setAlphaDomain,
    setAlphaAmount,
    setIsExternalDomain,
    setFutureBillingDate,
    setAlphaKeyCount,
    setAlphaPowerboostCount,
  ])
  const isWorkforceCenter = selectedPlan?.name === 'Workforce Center Plus'
  // console.log('isWorkforceCenter :: ', isWorkforceCenter)
  const isPlanInKeapFamily =
    KEAP_FAMILY_CODES.includes(selectedPlan?.code) ||
    KEAP_FAMILY_ANNUAL_CODES.includes(selectedPlan?.code)
  const isMarketingCenter =
    selectedPlan?.name.toLowerCase().includes('marketing center') ||
    isPaidMCTrial
  const isLeadLift = selectedPlan?.code === 'addon-5-leadslift-m2m'
  const isLeadLiftBni = selectedPlan?.code === 'addon-5-leadslift-bni-m2m'
  const [picked, setPicked] = useState(null)
  const [LLpicked, setLLpicked] = useState(true)
  const recommendedSEOPrice = useRef()
  const isThryvLeads = [
    'tl-mc-5-thryv-m2m',
    'tl-tax-5-thryv-m2m',
    'tl-5-thryv-m2m',
  ].includes(selectedPlan?.code)
  const isMC20InCart = MC_2_0_PLANS.some(code =>
    selectedCentersAndApps?.centers?.some(c => c.code === code),
  )
  let thryvLeadAlreadyExist
  if (isThryvLeads && isNewTLMCAccessible) {
    thryvLeadAlreadyExist =
      selectedCentersAndApps?.centers.find(
        item =>
          [
            'tl-mc-5-thryv-m2m',
            'tl-tax-5-thryv-m2m',
            'tl-5-thryv-m2m',
          ].includes(item.code) && item?.alreadyIncluded,
      ) ||
      selectedCentersAndApps?.apps.find(
        item =>
          [
            'tl-mc-5-thryv-m2m',
            'tl-tax-5-thryv-m2m',
            'tl-5-thryv-m2m',
          ].includes(item.code) && item?.alreadyIncluded,
      )
  }

  useEffect(() => {
    if (!isThryvLeads || !isMC20InCart || tlDomainConfig.value) return
    if (mcDomainConfig.isValid) {
      setTlDomainConfig(mcDomainConfig)
    } else if (existingMc2DomainValue) {
      setTlDomainConfig({value: existingMc2DomainValue, isValid: true})
    }
  }, [isThryvLeads, isMC20InCart, existingMc2DomainValue])

  // FULSAS-12507: pre-populate the Leads Lift domain field, preferring the
  // domain already entered for the Marketing Center plan in this order
  // (mcDomainConfig) and otherwise falling back to the domain already on
  // file for the account's existing Thryv 2.0 (MC 2.0) plan, when one
  // exists. Mirrors the Thryv Leads effect above. Treated as already-valid
  // since it was previously accepted/validated - the user can still edit
  // it, which re-runs DomainValidation's own checks.
  useEffect(() => {
    if (!isLeadLift || !isMC20InCart || llDomainConfig.value) return
    if (mcDomainConfig.isValid) {
      setLlDomainConfig(mcDomainConfig)
    } else if (existingMc2DomainValue) {
      setLlDomainConfig({value: existingMc2DomainValue, isValid: true})
    }
  }, [isLeadLift, isMC20InCart, existingMc2DomainValue])

  const isMCProEnhanced = selectedPlan?.code === 'mc_pro_enh-5-thryv-m2m'
  const isContinueDisabledForHomeServices =
    isHomeServices && paymentType.value === ''
  const isContinueDisabledForMCTrialOnboarding =
    isMCTrialOnboardingRequired && !onboardingRequired.value
  const isContinueDisabledForMC2OnboardingFee =
    isMCTrialOnboardingFeeRequired && !onboardingFeeRequired.value
  const isContinueDisabledForSEO =
    isSEO &&
    (!proposalValidation?.isValidProposal ||
      (!seoDomainConfig.isValid && !isMCProEnhanced))
  const isContinueDisabledForAlphaSEO =
    (isNewSEO &&
      alphaSEOFromRecurly.alphaProposalId === alphaProposalId &&
      alphaSEOFromRecurly.alphaKeyCount === alphaKeyCount &&
      alphaSEOFromRecurly.alphaPowerboostCount === alphaPowerboostCount) || // upgrade scenario , disable = true
    /*alphaSEOFromRecurly.alphaCategories === categories &&
      alphaSEOFromRecurly.alphaGeos === geos */ (isNewSEO &&
      !(
        Number(alphaProposalId) > 0 &&
        alphaDomain.length > 0 &&
        // categories.length > 0 &&
        // geos.length > 0 &&
        (isExternalDomain === 'yes' || isExternalDomain === 'no')
      )) //New scenario disable = true

  let isContinueDisabledForKeapMax
  if (isPlanInKeapFamily) {
    if (
      isFreeTrailCustomer &&
      ((isFreeTrailCustomer === 'yes' &&
        keapTrailAppId &&
        keapTrailAppId.length > 0) ||
        isFreeTrailCustomer === 'no')
    )
      isContinueDisabledForKeapMax = false
    else isContinueDisabledForKeapMax = true
  }

  const isMCDomainValid =
    mcDomainConfig.isValid || (isPaidMCTrial && !mcDomainConfig.value)

  let isContinueDisabledForMC =
    isMarketingCenter &&
    (!isMCDomainValid ||
      (selectedPlan.name === 'Thryv Signature + Expanded Listings' &&
        !isLegacyUpgradeAllowed))

  const isContinueDisabledForLL = isLeadLift && LLpicked

  // =============================================================
  //  condition to override during keap acc mc selection
  // if (
  //   isContinueDisabledForMC &&
  //   ['Marketing Center Plus', 'Marketing Center Pro'].includes(
  //     selectedPlan.name,
  //   ) &&
  //   keapAccount
  // ) {
  //   isContinueDisabledForMC = false
  // }
  // ==============================================================
  const isContinueDisabledForThryvLeads =
    isThryvLeads && !thryvLeadsValidation?.passed
  const isContinueDisabledForTLDomain =
    isThryvLeads && isMC20InCart && !tlDomainConfig.isValid
  const isContinueDisabledForLLDomain =
    isLeadLift && isMC20InCart && !llDomainConfig.isValid
  const itemConfig = getItemConfig(selectedPlan)
  const isCanAusNz = ['CA', 'AU', 'NZ'].includes(selectedCountry)
  const convertSeoNg =
    selectedPlan?.code === 'seombg-5-thryv-m2m' &&
    proposalValidation?.price < recommendedSEOPrice.current
  const isWebsiteAppAlreadyIncluded = defaultCentersAndApps?.apps?.some(
    ({code}) => code === 'addon-5-website_difm',
  )
  const isSEOAlreadyIncluded =
    defaultCentersAndApps?.centers?.some(
      ({code}) => code === 'seobase-5-thryv-m2m',
    ) ||
    defaultCentersAndApps?.apps?.some(
      ({code}) => code === 'seobase-5-thryv-m2m',
    )
  const wasWebsiteAppAddedToCart = selectedCentersAndApps?.apps?.some(
    ({code, alreadyIncluded}) =>
      code === 'addon-5-website_difm' && !alreadyIncluded,
  )
  const planWebsiteEnt = selectedPlan?.entitlements?.find(
    ({code}) => code === 'ent-5-website',
  )

  const isWebsiteEntAlreadyInOrder = checkIfAdded(
    selectedCentersAndApps?.centers,
    'Professionally Designed Website',
    'ent',
  )

  const isHourlyDataService =
    selectedPlan?.code === 'addon-5-keap-hourlydatasvc'

  const isKeapAdditionalUsers =
    selectedPlan?.code === 'addon-5-keap-addusers-m2m'

  const isKeapAdditionalUsersAnnual =
    selectedPlan?.code === 'addon-5-keap-addusers-annual'

  const isCustomDoneForYou = selectedPlan?.code === 'addon-5-keap-custdfy-ot'

  const isKeapAdditionalContacts =
    selectedPlan?.code === 'addon-5-keap-addcontacts-m2m'

  const isContinueDisabledKeapAdditionalContacts =
    isKeapAdditionalContacts && selectedAdditionalContactOption.name === ''

  const isKeapAdditionalContactsAnnual =
    selectedPlan?.code === 'addon-5-keap-addcontacts-annual'

  const isContinueDisabledKeapAdditionalContactsAnnual =
    isKeapAdditionalContactsAnnual &&
    selectedAdditionalContactOptionAnnual.name === ''

  const isKeapAdditionalContactsGraphlyAnnual =
    selectedPlan?.code === 'addon-5-keap-legacy-graphly-contacts-annual'

  const isContinueDisabledKeapAdditionalContactsGraphlyAnnual =
    isKeapAdditionalContactsGraphlyAnnual &&
    selectedAdditionalContactOptionGraphlyAnnual.name === ''

  const isKeapPlusThisPremiumAnnual =
    selectedPlan?.code === 'addon-5-keap-legacy-plusthis-premium-trans-annual'

  const isContinueDisabled =
    isKeapPlusThisPremiumAnnual && selectedPlusThisPremiumAnnual.name === ''

  const isKeapAdditionalContactsGraphlyM2m =
    selectedPlan?.code === 'addon-5-keap-legacy-graphly-contacts-m2m'

  const isContinueDisabledKeapAdditionalContactsGraphlyM2m =
    isKeapAdditionalContactsGraphlyM2m &&
    selectedAdditionalContactOptionGraphlyM2m.name === ''

  const isKeapPlusThisPremiumM2m =
    selectedPlan?.code === 'addon-5-keap-legacy-plusthis-premium-trans-m2m'

  const isContinueDisabledPlusThisPremiumM2m =
    isKeapPlusThisPremiumM2m && selectedPlusThisPremiumM2m.name === ''

  const isKeapTextVoice = selectedPlan?.code === 'addon-5-keap-textvoice-m2m'

  const isContinueDisabledKeapTextVoice =
    isKeapTextVoice && selectedKeapTextVoice.name === ''

  const isKeapTextVoiceAnnual =
    selectedPlan?.code === 'addon-5-keap-textvoice-annual'

  const isContinueDisabledKeapTextVoiceAnnual =
    isKeapTextVoiceAnnual && selectedKeapTextVoiceAnnual.name === ''

  const isKcpCertification = selectedPlan?.code === 'keap_kcp-cert-5-fee-annual'
  const isContinueDisabledKcpCertification =
    isKcpCertification && selectedKcpOption.name == ''

  const isKccCertificationAnnual =
    selectedPlan?.code === 'keap_kcc-cert-5-fee-annual'

  const handleSelectOption = option => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter(o => o !== option))
    } else {
      if (option.name === 'Professionally Designed Website') {
        setIsWebsiteSettingsModalVisible(true)
      }
      setSelectedOptions([...selectedOptions, option])
    }
  }
  const hvacMcServicesM2MAddOn = (all5PlanPrices?.apps || [])
    .map(app => formatItem(app, selectedCountry, keapMaxIcon, 'Keap Add-Ons'))
    .filter(app => app.code === 'vert_mc_clientsvcs-5-thryv-m2m')[0]
  const hvacMcServicesDesignM2MAddOn = (all5PlanPrices?.apps || [])
    .map(app => formatItem(app, selectedCountry, keapMaxIcon, 'Keap Add-Ons'))
    .filter(app => app.code === 'vert_mc_web_clientsvcs-5-thryv-m2m')[0]
  const hvacServicesM2MAddOn = (all5PlanPrices?.apps || [])
    .map(app => formatItem(app, selectedCountry, keapMaxIcon, 'Keap Add-Ons'))
    .filter(app => app.code === 'vert_clientsvcs-5-thryv-m2m')[0]
  const hvacMcServicesOtAddOn = (all5PlanPrices?.oneTimeFees || [])
    .map(oneTimeFee =>
      formatItem(oneTimeFee, selectedCountry, keapMaxIcon, 'Keap Add-Ons'),
    )
    .filter(
      oneTimeFee => oneTimeFee.code === 'vert_mc_clientsvcs-5-thryv-ot',
    )[0]
  const hvacMcServicesDesignOtAddOn = (all5PlanPrices?.oneTimeFees || [])
    .map(oneTimeFee =>
      formatItem(oneTimeFee, selectedCountry, keapMaxIcon, 'Keap Add-Ons'),
    )
    .filter(
      oneTimeFee => oneTimeFee.code === 'vert_mc_web_clientsvcs-5-thryv-ot',
    )[0]
  const hvacServicesOtAddOn = (all5PlanPrices?.oneTimeFees || [])
    .map(oneTimeFee =>
      formatItem(oneTimeFee, selectedCountry, keapMaxIcon, 'Keap Add-Ons'),
    )
    .filter(oneTimeFee => oneTimeFee.code === 'vert_clientsvcs-5-thryv-ot')[0]

  const handleAddToOrder = () => {
    const shouldAllowMultipleInSameGroup = (code1, code2) => {
      const ALLOW_MULTIPLE_CODES = [
        'tl-mc-5-thryv-m2m',
        'tl-tax-5-thryv-m2m',
        'seobase-5-thryv-m2m',
      ]
      const ALLOW_KCP_KCC_CODES = [
        'keap_kcp-cert-5-fee-annual',
        'keap_kcc-cert-5-fee-annual',
      ]
      // If both codes are in the allow list, they can coexist
      return (
        (ALLOW_MULTIPLE_CODES.includes(code1) &&
          ALLOW_MULTIPLE_CODES.includes(code2) &&
          code1 !== code2) ||
        (ALLOW_KCP_KCC_CODES.includes(code1) &&
          ALLOW_KCP_KCC_CODES.includes(code2) &&
          code1 !== code2)
      )
    }
    // Build the MC Foundation cart entry from the dynamic catalog when
    // present, falling back to the legacy literal so seed/test gaps don't
    // regress behavior. unitAmount/amount/img/planType/groupTitle stay
    // static — MC Foundation is the $0 tier with a fixed icon and group.
    const buildMcFoundationCenter = () => {
      const fromCatalog = all5PlanPrices?.centers?.find(
        c => c.code === 'mc_foundation-5-thryv-m2m',
      )
      return {
        id: fromCatalog?.id || 'marketingFound',
        code: 'mc_foundation-5-thryv-m2m',
        name: fromCatalog?.name || 'Marketing Center Foundation',
        quantity: 1,
        unitAmount: 0,
        amount: 0,
        img: marketingCenterIcon,
        entitlements: fromCatalog?.entitlements || [],
        planType: 'center',
        excludes: fromCatalog?.excludes || [],
        requiresCenter: fromCatalog?.requiresCenter || [],
        groupTitle: 'Marketing Center',
      }
    }

    let requiredOptions = []
    if (selectedPlan.code === 'keap_kcp-cert-5-fee-annual') {
      requiredOptions = selectedPlan.entitlements
    } else if (selectedPlan.code === 'keap_kcc-cert-5-fee-annual') {
      requiredOptions = selectedPlan.entitlements
    } else {
      requiredOptions =
        selectedPlan.entitlements?.filter(
          entitlement =>
            entitlement.isRequired &&
            !selectedCentersAndApps.centers.some(({entitlements}) =>
              entitlements?.some(
                ({name, alreadyIncluded}) =>
                  name === entitlement.name && alreadyIncluded,
              ),
            ),
        ) || []
    }

    const isCommandCenter = selectedPlan?.code.toLowerCase().startsWith('cc_')
    const isCCPro = selectedPlan?.name.toLowerCase().includes('pro')
    const ccSeatsCode = isCCPro ? 'addon-5-seats_ccpro' : 'addon-5-seats_ccplus'
    const isWebsiteApp =
      selectedPlan?.name === 'Professionally Designed Website'

    const includesWebsite = selectedOptions.some(
      option => option.name === 'Professionally Designed Website',
    )

    const includesLogo = selectedPlan.name === 'Professional Designed Logo'
    const isKeapFamilyPlan = KEAP_FAMILY_CODES.includes(selectedPlan?.code)
    const isKeapFamilyAnnualPlan = KEAP_FAMILY_ANNUAL_CODES.includes(
      selectedPlan?.code,
    )

    const isKeapMonthlyAddon = (all5PlanPrices?.apps ?? [])
      .filter(
        app =>
          app.uigroup === 'Keap Add-Ons' &&
          app.productBillingType != 'Annual' &&
          app.parentProduct === 'addon-5-keap-addons',
      )
      .map(app => app.code)
      .includes(selectedPlan?.code)
    const isKeapAnnualAddon = (all5PlanPrices?.apps ?? [])
      .filter(
        app =>
          app.uigroup === 'Keap Add-Ons' &&
          app.productBillingType === 'Annual' &&
          app.parentProduct === 'addon-5-keap-addons-annual',
      )
      .map(app => app.code)
      .includes(selectedPlan?.code)

    const shouldTreatAsCenterPlan =
      selectedPlan.planType === 'center' ||
      isKeapFamilyPlan ||
      isKeapFamilyAnnualPlan
    const centerType =
      shouldTreatAsCenterPlan && selectedPlan.groupTitle?.split(' ')[0]
    const isSignaturesPaidInCart = selectedCentersAndApps.apps.some(
      ({code}) => code === 'addon-5-signatures',
    )
    // if (selectedPlan?.code === 'wc_plus-5-thryv-m2m') {
    //   toast.warning(
    //     'Review/Approval can take up to 3 business days, after filling out the Company Onboarding wizard',
    //   )
    // }
    const isKccPlan =
      selectedPlan?.code === 'keap_kcc-cert-5-fee-annual' ||
      selectedPlan?.code === 'keap_kcp-cert-5-fee-annual'

    // Resolve plan code based on website entitlement selection and swap_when_selected flag
    const resolvedPlanCode = (() => {
      if (!selectedPlan?.alternatePlanCodes?.length) return selectedPlan.code
      const swapWhenSelected = includesWebsite ? 1 : 0
      const entry = selectedPlan.alternatePlanCodes.find(
        e =>
          e.entitlement_code === 'ent-5-website' &&
          e.swap_when_selected === swapWhenSelected,
      )
      return entry ? entry.alternate_plan_code : selectedPlan.code
    })()
    const resolvedPlan = (() => {
      if (resolvedPlanCode === selectedPlan.code) return selectedPlan
      const apiPlan = (all5PlanPrices?.centers ?? []).find(
        c => c.code === resolvedPlanCode,
      )
      if (!apiPlan) return selectedPlan
      const {unitAmount: resolvedUnitAmount} = findUnitAmount(
        apiPlan.currencies,
        selectedCountry,
        null,
      )
      return {
        ...selectedPlan,
        code: resolvedPlanCode,
        amount: resolvedUnitAmount,
        unitAmount: resolvedUnitAmount,
        currencies: apiPlan.currencies,
      }
    })()
    let selectedPlanWithOptions = {
      ...resolvedPlan,
      code: resolvedPlanCode,
      entitlements: isKccPlan
        ? requiredOptions
        : [...selectedOptions, ...requiredOptions],
      quantity,
    }

    // addon-5-keap-addusers-m2m: ensure unitAmount and amount (unit price) are set for CartItem/calcTotal
    if (selectedPlan.code === 'addon-5-keap-addusers-m2m') {
      const keapAddons = all5PlanPrices?.apps?.find(
        a => a.code === 'addon-5-keap-addons',
      )
      const keapAddUsersAddon = keapAddons?.addons?.find(
        a => a.code === 'addon-5-keap-addusers-m2m',
      )
      const directAddon = all5PlanPrices?.apps?.find(
        a => a.code === 'addon-5-keap-addusers-m2m',
      )
      const currenciesSource =
        keapAddUsersAddon?.currencies ||
        directAddon?.currencies ||
        selectedPlan.currencies
      if (currenciesSource) {
        const {unitAmount: addUsersUnitAmount} = findUnitAmount(
          currenciesSource,
          selectedCountry,
          null,
        )
        if (addUsersUnitAmount != null) {
          selectedPlanWithOptions = {
            ...selectedPlanWithOptions,
            unitAmount: addUsersUnitAmount,
            amount: addUsersUnitAmount,
          }
        }
      }
    }

    // addon-5-keap-addusers-annual: ensure unitAmount and amount (unit price) are set for CartItem/calcTotal
    if (selectedPlan.code === 'addon-5-keap-addusers-annual') {
      const keapAddons = all5PlanPrices?.apps?.find(
        a => a.code === 'addon-5-keap-addons-annual',
      )
      const keapAddUsersAddon = keapAddons?.addons?.find(
        a => a.code === 'addon-5-keap-addusers-annual',
      )
      const directAddon = all5PlanPrices?.apps?.find(
        a => a.code === 'addon-5-keap-addusers-annual',
      )
      const currenciesSource =
        keapAddUsersAddon?.currencies ||
        directAddon?.currencies ||
        selectedPlan.currencies
      if (currenciesSource) {
        const {unitAmount: addUsersUnitAmount} = findUnitAmount(
          currenciesSource,
          selectedCountry,
          null,
        )
        if (addUsersUnitAmount != null) {
          selectedPlanWithOptions = {
            ...selectedPlanWithOptions,
            unitAmount: addUsersUnitAmount,
            amount: addUsersUnitAmount,
          }
        }
      }
    }

    if (isKeapFamilyPlan || isKeapFamilyAnnualPlan) {
      const selectedOptionsByKey = new Map(
        (selectedOptions || []).map(entitlement => [
          entitlement?.code || entitlement?.name,
          entitlement,
        ]),
      )
      const normalizedKeapEntitlements = (selectedPlan?.entitlements || [])
        .filter(entitlement => {
          const key = entitlement?.code || entitlement?.name
          return entitlement?.isRequired || selectedOptionsByKey.has(key)
        })
        .map(entitlement => {
          if (entitlement?.isRequired) return entitlement
          const key = entitlement?.code || entitlement?.name
          return selectedOptionsByKey.get(key) || entitlement
        })

      selectedPlanWithOptions = {
        ...selectedPlanWithOptions,
        entitlements: normalizedKeapEntitlements,
      }
    }

    if (convertSeoNg) {
      toast.warning('Attn: SEO is no longer guaranteed.')
      const {
        amount,
        img,
        entitlements,
        id,
        excludes,
        requiresCenter,
        code,
        name,
      } = centers.find(({code}) => code === 'seo-5-thryv-m2m')
      selectedPlanWithOptions = {
        ...selectedPlanWithOptions,
        name,
        amount,
        img,
        entitlements,
        id,
        excludes,
        requiresCenter,
        code,
      }
    }

    selectedPlanWithOptions = {
      ...selectedPlanWithOptions,
      ...(includesWebsite &&
        sensisSiteDomain && {
          entitlements: selectedOptions.map(option =>
            option.name === 'Professionally Designed Website'
              ? {
                  ...option,
                  sensisSiteDomain,
                  applicableOneTimes: option.applicableOneTimes,
                }
              : option,
          ),
        }),
      ...(isWebsiteApp && sensisSiteDomain && {sensisSiteDomain}),
      ...(isNewSEO && {
        alphaProposalId: alphaProposalId,
        alphaAmount: alphaAmount,
        quantity: 1,
        amount: alphaAmount,
        alphaDomain: alphaDomain,
        isExternalDomain,
        ...(futureBillingDate && {
          startDate: futureBillingDate,
        }),
        // alphaCategories: categories,
        // alphaGeos: geos,
      }),
      ...(isLeadLift && {
        quantity:
          getAmountToQuantityMap(selectedCountry)[
            Math.round(
              Number(
                String(picked?.amountNum ?? planAmountNum).replace(
                  /[^0-9.]/g,
                  '',
                ),
              ),
            )
          ] ??
          (Math.floor(
            (Number(
              String(picked?.amountNum ?? planAmountNum).replace(
                /[^0-9.]/g,
                '',
              ),
            ) || 0) / (selectedCountry === 'NZ' ? 1 : 1.1),
          ) ||
            1),
        amount: Number(picked?.amountNum ?? planAmountNum) || 1,
        unitAmount: Number(picked?.amountNum ?? planAmountNum) || 1,
        ...(isMC20InCart &&
          llDomainConfig.value && {
            llDomain: llDomainConfig.value,
          }),
      }),

      ...(isSEO && {
        seoProposalId: proposalId,
        amount: proposalValidation.price,
        quantity: proposalValidation?.price,
        ...(futureBillingDate && {
          startDate: futureBillingDate,
        }),
        seoDomain: seoDomainConfig.value,
      }),
      ...(isThryvLeads && {
        thryvLeadsId,
        amount: thryvLeadsValidation?.budget ?? selectedPlan?.amount,
        ...(futureBillingDate && {
          startDate: futureBillingDate,
        }),
        quantity: thryvLeadsValidation?.budget ?? selectedPlan?.amount,
        ...(isMC20InCart &&
          tlDomainConfig.value && {
            tlDomain: tlDomainConfig.value,
          }),
      }),
      ...(isMarketingCenter && {mcDomain: mcDomainConfig.value}),
      ...(isMCTrialOnboardingRequired && {
        mcDomain: mcDomainConfig.value,
        onboardingRequired: onboardingRequired,
      }),
      ...(isMCTrialOnboardingFeeRequired && {
        mcDomain: mcDomainConfig.value,
        onboardingFeeRequired: onboardingFeeRequired,
      }),
      ...(showIncludeOnboardingToggle && {
        includeOnboarding: includeOnboarding,
      }),
      ...(isPlanInKeapFamily && {
        keapDomain: keapDomainConfig.value,
        keapFreeTrailId: keapTrailAppId,
      }),
      ...(isCommandCenter && {
        entitlements: [
          {
            code: ccSeatsCode,
            quantity: seatQty,
          },
        ],
      }),
      ...(includesLogo && {
        quantity: quantity,
      }),
      ...(isWebsiteAppAlreadyIncluded &&
        planWebsiteEnt &&
        !isWebsiteEntAlreadyInOrder && {
          entitlements: [
            ...selectedOptions,
            {
              ...planWebsiteEnt,
              alreadyIncluded: true,
              ...(sensisSiteDomain && {sensisSiteDomain}),
            },
          ],
        }),
      ...(wasWebsiteAppAddedToCart &&
        planWebsiteEnt && {
          entitlements: [
            ...selectedOptions,
            {
              ...planWebsiteEnt,
              ...(sensisSiteDomain && {sensisSiteDomain}),
            },
          ],
        }),
      ...(selectedPlan?.code.includes('addon-5-ai-webbuilder') && {
        quantity: aiWebsiteBuilderQuantity,
        groupTitle: 'Thryv Add-Ons',
      }),
      ...(selectedPlan?.code.includes('addon-socialads') && {
        quantity: socialAdsQuantity,
        groupTitle: 'Thryv Add-Ons',
      }),
      ...(['addon-ctn-bninat-m2m', 'addon-ctn-bninat-annual'].includes(
        selectedPlan?.code,
      ) && {
        quantity: ctnQuantity,
        groupTitle: 'Call Tracking Number',
      }),
    }
    const disableApps = selectedPlanWithOptions.disableApps || []
    const disableCenters = selectedPlanWithOptions.disableCenters || []
    const data = {
      centers: [...structuredClone(selectedCentersAndApps.centers)],
      apps: [...structuredClone(selectedCentersAndApps.apps)],
      oneTimes: [...structuredClone(selectedCentersAndApps.oneTimes)],
    }

    if (CC_THRYV_SUCCESS_SERVICES_CODES.includes(selectedPlan?.code)) {
      data.apps = data.apps.filter(
        app => !CC_THRYV_SUCCESS_SERVICES_CODES.includes(app?.code),
      )
    }

    if (selectedPlan.code === 'keap_kcc-cert-5-fee-annual') {
      data.centers = data.centers.filter(
        center => center.code != 'keap_kcc-cert-5-fee-annual',
      )
    }

    // Add Keap Add Ons, when any monthly keap plan is added to the order
    if (isKeapFamilyPlan) {
      const hasKeapAddonsParent = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons',
      )
      const hasKeapAddonMonthlyLegacyParent = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons-legacy-m2m',
      )
      // Add monthly keap addons if not present
      if (!hasKeapAddonsParent && !hasKeapAddonMonthlyLegacyParent) {
        data.apps.push({
          id: 'keapaddons',
          code: 'addon-5-keap-addons',
          name: 'Keap Add-Ons',
          quantity: 1,
          groupTitle: 'Keap Add-Ons',
          unitAmount: apps.find(app => app.code === 'addon-5-keap-addons')
            ?.amount,
          amount: apps.find(app => app.code === 'addon-5-keap-addons')?.amount,
          img: reverseGreenPlusIcon,
        })
      }
      // Remove legacy monthly centers from cart
      data.centers = data.centers.filter(
        center => !KEAP_FAMILY_LEGACY_CODES.includes(center.code),
      )
      // Remove legacy monthly keap addons parent and its child items from apps list
      // const hasKeapAddonMonthlyLegacyParent = data.apps.some(
      //   ({code}) => code === 'addon-5-keap-addons-legacy-m2m',
      // )
      // if (hasKeapAddonMonthlyLegacyParent) {
      //   data.apps = data.apps.filter(
      //     app => app.code !== 'addon-5-keap-addons-legacy-m2m',
      //   )
      // }
      // Remove keap Addons Annual if present , this can happen only in case of new order
      const hasKeapAddonsAnnual = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons-annual',
      )
      if (hasKeapAddonsAnnual) {
        data.apps = data.apps.filter(
          app =>
            app.code != 'addon-5-keap-addons-annual' &&
            !(all5PlanPrices?.apps ?? [])
              .filter(
                item => item.parentProduct === 'addon-5-keap-addons-annual',
              )
              .map(item => item.code)
              .includes(app.code),
        )
      }
    } else if (isKeapMonthlyAddon) {
      // Check if keap monthly addon is being added which has a legacy version, and is already present on the account, remove the legacy version of the addon
      let legacyProducts = (all5PlanPrices?.apps ?? []).filter(
        item => item.code === selectedPlan.code,
      ).legacyProducts

      if (
        legacyProducts &&
        data.apps.filter(app => legacyProducts.includes(app.code))
      ) {
        data.apps = data.apps.filter(app => !legacyProducts.includes(app.code))
      }
    }

    // Add Keap Add Ons Annual, when any annual keap plan is added to the order
    if (isKeapFamilyAnnualPlan) {
      const hasKeapAddonsAnnualParent = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons-annual',
      )
      const hasKeapAddonAnnualLegacyParent = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons-legacy-annual',
      )
      // Add Annual keap -Addons, If not present
      if (!hasKeapAddonsAnnualParent && !hasKeapAddonAnnualLegacyParent) {
        data.apps.push({
          id: 'keapaddonsannual',
          code: 'addon-5-keap-addons-annual',
          name: 'Keap Add-Ons Yearly',
          quantity: 1,
          groupTitle: 'Keap Add-Ons',
          unitAmount: apps.find(
            app => app.code === 'addon-5-keap-addons-annual',
          )?.amount,
          amount: apps.find(app => app.code === 'addon-5-keap-addons-annual')
            ?.amount,
          img: reverseGreenPlusIcon,
        })
      }
      // Remove the Legacy Annual keap plan
      data.centers = data.centers.filter(
        center => !KEAP_FAMILY_LEGACY_ANNUAL_CODES.includes(center.code),
      )
      // const hasKeapAddonAnnualLegacyParent = data.apps.some(
      //   ({code}) => code === 'addon-5-keap-addons-legacy-annual',
      // )
      // Remove leagcy annual keap addons and its associated child items from apps list
      // if (hasKeapAddonAnnualLegacyParent) {
      //   data.apps = data.apps.filter(
      //     app => app.code != 'addon-5-keap-addons-legacy-annual',
      //   )
      // }
      // Remove keap Addons monthly if present , this can happen only in case of new order
      const hasKeapAddonMonthly = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons',
      )
      if (hasKeapAddonMonthly) {
        data.apps = data.apps.filter(
          app =>
            app.code != 'addon-5-keap-addons' &&
            !(all5PlanPrices?.apps ?? [])
              .filter(item => item.parentProduct === 'addon-5-keap-addons')
              .map(item => item.code)
              .includes(app.code),
        )
      }
    } else if (isKeapAnnualAddon) {
      // Check if annual addon being added has a legacy version which is already present on the account, If yes, remove the legacy version of the addon
      let legacyProducts = (all5PlanPrices?.apps ?? []).find(
        item => item.code === selectedPlan.code,
      )?.legacyProducts

      if (
        legacyProducts &&
        data.apps.filter(app => legacyProducts.includes(app.code))
      ) {
        data.apps = data.apps.filter(app => !legacyProducts.includes(app.code))
      }
    }
    if (MC_2_0_PREMIERPLANS.includes(selectedPlan?.code)) {
      data.apps = data.apps.filter(
        ({code}) => code !== 'addon-5-keap-addons-annual',
      )
      const hasKeapAddons = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons',
      )
      if (!hasKeapAddons) {
        data.apps.push({
          id: 'keapaddons',
          code: 'addon-5-keap-addons',
          name: 'Keap Add-Ons',
          quantity: 1,
          groupTitle: 'Keap Add-Ons',
          unitAmount: apps.find(app => app.code === 'addon-5-keap-addons')
            ?.amount,
          amount: apps.find(app => app.code === 'addon-5-keap-addons')?.amount,
          img: reverseGreenPlusIcon,
        })
      }
    }
    if (MC_2_0_PREMIERPLANS.includes(selectedPlan?.code)) {
      data.apps = data.apps.filter(({code}) => code !== 'addon-5-keap-addons')
      const hasKeapAddonsAnnual = data.apps.some(
        ({code}) => code === 'addon-5-keap-addons-annual',
      )
      if (!hasKeapAddonsAnnual) {
        const keapAddonsAnnual = apps.find(
          app => app.code === 'addon-5-keap-addons-annual',
        )
        data.apps.push({
          id: 'keapaddonsannual',
          code: 'addon-5-keap-addons-annual',
          name: 'Keap Add-Ons',
          quantity: 1,
          groupTitle: 'Keap Add-Ons',
          unitAmount: keapAddonsAnnual?.amount,
          amount: keapAddonsAnnual?.amount,
          img: reverseGreenPlusIcon,
        })
      }
    }
    const isAddingKeapFamilyOrHvac =
      isKeapFamilyPlan || selectedPlan.code === 'hvac-5-thryv-m2m'
    const bcProOrUnlmSelected = data.centers.find(
      center =>
        center.code === 'bc_pro-5-thryv-m2m' ||
        center.code === 'bc_unlm-5-thryv-m2m',
    )
    const mcProSelected = data.centers.find(
      center => center.code === 'mc_pro-5-thryv-m2m',
    )
    if (
      isAddingKeapFamilyOrHvac &&
      isMCAlreadyPresent &&
      isMCAlreadyPresent.length === 0
    ) {
      data.centers = data.centers.filter(
        item => !item.name.includes('Reporting Center'),
      )
    }

    // If the client has a website entitlement as part of a BC Pro or BC Unlimited complete the following:
    if (isAddingKeapFamilyOrHvac && bcProOrUnlmSelected) {
      const websiteEntitlement = bcProOrUnlmSelected.entitlements.find(
        entitlement => entitlement.code === 'ent-5-website',
      )
      // Does the client have an MC Pro? (existing or in order)
      if (websiteEntitlement && mcProSelected) {
        // If yes, move website entitlement over to MC Pro automatically & don’t charge design fee.
        mcProSelected.entitlements ??= []
        mcProSelected.entitlements.push(websiteEntitlement)
      } else if (websiteEntitlement && !mcProSelected) {
        // If no, present a pop up that asks “Does the client want to retain their Thryv website?”
        if (retainWebsiteModalState === RETAIN_WEBSITE_MODAL_STATES.CLOSE) {
          setRetainWebsiteModalState(RETAIN_WEBSITE_MODAL_STATES.OPEN)
          return
        }
        if (
          retainWebsiteModalState === RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES
        ) {
          // If yes, create a standalone Professionally Designed Website subscription & don’t charge design fee.
          const websiteAddon = apps.find(
            app => app.code === 'addon-5-website_difm',
          )
          const noWebsiteAddonAlreadyInOrder = !data.apps.some(
            app => app.code === 'addon-5-website_difm',
          )
          if (websiteAddon && noWebsiteAddonAlreadyInOrder) {
            data.apps.push({
              ...websiteAddon,
              quantity: 1,
              subtotal: websiteAddon.amount,
              unitAmount: websiteAddon.amount,
            })
          }
        }
        // If no, cancel the BC subscription including website entitlement.
      }
    }

    data.apps = data.apps.filter(app => !disableApps.includes(app.code))
    data.centers = data.centers.filter(
      center => !disableCenters.includes(center.code),
    )

    const isMC20PlanSelected = MC_2_0_SIGPREMIERPLANS.includes(
      selectedPlan?.code,
    )
    // FULSAS-12295: a new Keap product makes thryvprfee a fresh charge, not
    // a duplicate of the Starter onboarding opt-in — don't waive it here.
    const isKeapInCartForOnboarding = data.centers.some(c =>
      KEAP_FAMILY_CODES.includes(c.code),
    )

    data.oneTimes = data.oneTimes.filter(item => {
      if (
        item.code === 'thryvdesg2' &&
        (isWebsiteDesignFeeWaived ||
          isMC20PlanSelected ||
          mc20WebsiteDowngradeModalState ===
            RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES)
      ) {
        return false
      }
      if (
        (item.code === 'keap-ignite-thryvprfee' ||
          item.code === 'thryvprfee') &&
        (onboardingFeeRequired?.value === 'No' ||
          (includeOnboarding?.value === 'Yes' && !isKeapInCartForOnboarding))
      ) {
        return false
      }
      return true
    })

    const websiteApp = data.apps.find(
      app => app.code === 'addon-5-website_difm',
    )
    if (isSignaturesPaidInCart && selectedPlan.code === 'bc_unlm-5-thryv-m2m') {
      data.apps = data.apps.filter(app => app.code !== 'addon-5-signatures')
    }
    if (includesWebsite && websiteApp) {
      data.apps = data.apps.filter(app => app.code !== 'addon-5-website_difm')
    }
    let isCenterDowngrade = false
    let prevCenter
    if (selectedPlan.groupTitle?.includes(centerType)) {
      //  if (centerType !== 'Thryv') {
      // prevCenter = data.centers.find(plan =>
      //   plan.groupTitle.includes(
      //     selectedPlanWithOptions.groupTitle.split(' ')[0],
      //   ),
      // )
      let centersWithUIGroup = []
      for (let i = 0; i < (all5PlanPrices?.centers?.length ?? 0); i++) {
        if (
          all5PlanPrices?.centers[i]?.uigroup?.includes(
            selectedPlan?.groupTitle,
          )
        ) {
          centersWithUIGroup.push(all5PlanPrices.centers[i])
        }
      }
      prevCenter = data.centers.find(center =>
        centersWithUIGroup?.some(group => group.code === center.code),
      )
      // Check if these products can coexist
      const canCoexist =
        prevCenter &&
        shouldAllowMultipleInSameGroup(selectedPlan.code, prevCenter.code)
      // Only replace if they cannot coexist
      if (prevCenter && !canCoexist) {
        data.centers = data.centers.filter(
          plan => !plan.code.includes(prevCenter?.code),
        )
      }
    }

    // When MC Foundation is added, remove any MC 2.0 plans from the cart.
    // They live in the 'Thryv' UI group so the same-group prevCenter logic
    // above never finds or removes them.
    if (isTgpFoundationFamilyCode(selectedPlan.code)) {
      data.centers = data.centers.filter(
        center => !MC_2_0_PLANS.includes(center.code),
      )
    }

    // FULSAS-13789: Thryv Basic is not applicable alongside a legacy Marketing
    // Center or Business Center plan — adding one drops a cart-only Thryv Basic.
    if (isTgpFoundationBlockingCode(selectedPlan.code)) {
      data.centers = data.centers.filter(
        center => !isThryvBasicCode(center.code) || center.alreadyIncluded,
      )
    }

    // FULSAS-13789: Growth Packages are not allowed alongside TGP Foundation /
    // Thryv Basic — adding either drops a cart-only Growth Package.
    if (isTgpFoundationFamilyCode(selectedPlan.code)) {
      data.apps = data.apps.filter(
        app => !GROWTH_PACKAGES.includes(app.code) || app.alreadyIncluded,
      )
    }

    if (prevCenter && prevCenter?.productRank) {
      const currentPlanRank = selectedPlanWithOptions.productRank || 0
      if (prevCenter?.productRank > currentPlanRank) {
        isCenterDowngrade = true
      }
      // NEW: Monthly -> Annual (remove AI Website Builder addon if present)
      // if (
      //   prevCenter?.productBillingType === 'Monthly' &&
      //   selectedPlanWithOptions?.productBillingType === 'Annual'
      // ) {
      //   const hasAiWebBuilder = selectedCentersAndApps?.apps?.some(
      //     app => app?.code === 'addon-5-ai-webbuilder' && (app?.value ?? true),
      //   )

      //   if (hasAiWebBuilder) {
      //     selectedCentersAndApps.apps = (
      //       selectedCentersAndApps.apps || []
      //     ).filter(app => app?.code !== 'addon-5-ai-webbuilder')
      //     // data.apps.push(selectedCentersAndApps.apps)
      //     data.apps = (data.apps || []).filter(
      //       app => app?.code !== 'addon-5-ai-webbuilder',
      //     )
      //     // data.apps.push(selectedCentersAndApps.apps)
      //   }
      // }
    }
    // FULSAS-12280 / BUSREQ-14036/14038: downgrade access is Admin-only at
    // launch, driven by the MC_Downgrade_Access feature flag (features table,
    // same UserFeaturesContext mechanism as MC_AU/MC_NZ) rather than a
    // hardcoded role check, so additional roles can be enabled later without
    // a code change. Blocking here (plan-added-to-cart) rather than at order
    // submit keeps the reject as close to the user's action as possible;
    // order-service.js#assertDowngradeAccessAllowed re-checks server-side.
    // TGP-DOWNGRADE #7 (to revert: delete the `isTgpDowngradeToFoundation`
    // const and restore the condition to `if (isCenterDowngrade &&
    // !MC_Downgrade_Access) {`).
    // TGP Starter/Signature -> TGP Foundation / Thryv Basic is a TGP downgrade:
    // Enable_TGP_Downgrade is enough (MC_Downgrade_Access still works too).
    const isTgpDowngradeToFoundation = isTgpFoundationDowngrade(
      selectedPlan.code,
      prevCenter ? [prevCenter.code] : [],
    )
    if (
      isCenterDowngrade &&
      !(
        MC_Downgrade_Access ||
        (isTgpDowngradeToFoundation && Enable_TGP_Downgrade)
      )
    ) {
      toast.error('Your role is not authorized to downgrade this plan.')
      return
    }

    if (isCenterDowngrade) {
      if (
        selectedPlanWithOptions.downgrades &&
        selectedPlanWithOptions.downgrades?.length > 0
      ) {
        for (let downgrade of selectedPlanWithOptions.downgrades) {
          if (downgrade.dependentProductType === 'App') {
            data.apps = data.apps.filter(
              plan => !plan.code.includes(downgrade.dependentProductCode),
            )
          } else if (downgrade.dependentProductType === 'Entitlement') {
            selectedPlanWithOptions.entitlements =
              selectedPlanWithOptions.entitlements.filter(
                entitlement =>
                  !entitlement.code.includes(downgrade.dependentProductCode),
              )
          }
        }
      }

      // MC 2.0 website entitlement downgrade: if the previous plan (Signature
      // or Premier) had ent-5-website and the new plan does not include it,
      // ask whether to retain the website as a paid standalone add-on.
      const prevCenterHadWebsiteEnt =
        MC_2_0_SIGPREMIERPLANS.includes(prevCenter?.code) &&
        (prevCenter?.entitlements ?? []).some(e => e.code === 'ent-5-website')
      const newPlanHasWebsiteEnt = (
        selectedPlanWithOptions.entitlements ?? []
      ).some(e => e.code === 'ent-5-website')

      if (prevCenterHadWebsiteEnt && !newPlanHasWebsiteEnt) {
        if (
          mc20WebsiteDowngradeModalState === RETAIN_WEBSITE_MODAL_STATES.CLOSE
        ) {
          setMc20WebsiteDowngradeModalState(RETAIN_WEBSITE_MODAL_STATES.OPEN)
          setMc20WebsiteDowngradePlanName(prevCenter?.name ?? '')
          return
        }
        if (
          mc20WebsiteDowngradeModalState ===
          RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES
        ) {
          // Add the standalone website add-on without charging the design fee.
          const websiteAddon = apps.find(
            app => app.code === 'addon-5-website_difm',
          )
          const noWebsiteAddonAlreadyInOrder = !data.apps.some(
            app => app.code === 'addon-5-website_difm',
          )
          if (websiteAddon && noWebsiteAddonAlreadyInOrder) {
            data.apps.push({
              ...websiteAddon,
              quantity: 1,
              subtotal: websiteAddon.amount,
              unitAmount: websiteAddon.amount,
            })
          }
        }
        // ANSWERED_NO: proceed with downgrade, entitlement already stripped above.
      }
    }

    // MC Foundation cross-group website downgrade check:
    // MC Foundation is in the 'Marketing Center' group while MC 2.0 Sig/Premier
    // plans are in the 'Thryv' group, so the isCenterDowngrade path above never
    // fires. Check explicitly: if adding MC Foundation and the account already
    // has an MC 2.0 Sig/Premier plan with ent-5-website, prompt the user.
    if (isTgpFoundationFamilyCode(selectedPlan.code)) {
      const accountSigPremierCenter = defaultCentersAndApps.centers.find(
        ({code: c}) => MC_2_0_SIGPREMIERPLANS.includes(c),
      )
      const accountCenterHadWebsiteEnt =
        accountSigPremierCenter &&
        (accountSigPremierCenter.entitlements ?? []).some(
          e => e.code === 'ent-5-website',
        )
      const foundationHasWebsiteEnt = (
        selectedPlanWithOptions.entitlements ?? []
      ).some(e => e.code === 'ent-5-website')

      if (accountCenterHadWebsiteEnt && !foundationHasWebsiteEnt) {
        if (
          mc20WebsiteDowngradeModalState === RETAIN_WEBSITE_MODAL_STATES.CLOSE
        ) {
          setMc20WebsiteDowngradeModalState(RETAIN_WEBSITE_MODAL_STATES.OPEN)
          setMc20WebsiteDowngradePlanName(accountSigPremierCenter.name ?? '')
          return
        }
        if (
          mc20WebsiteDowngradeModalState ===
          RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES
        ) {
          const websiteAddon = apps.find(
            app => app.code === 'addon-5-website_difm',
          )
          const noWebsiteAddonAlreadyInOrder = !data.apps.some(
            app => app.code === 'addon-5-website_difm',
          )
          if (websiteAddon && noWebsiteAddonAlreadyInOrder) {
            data.apps.push({
              ...websiteAddon,
              quantity: 1,
              subtotal: websiteAddon.amount,
              unitAmount: websiteAddon.amount,
            })
          }
        }
      }
    }

    const isMCPlusInCart = selectedCentersAndApps?.centers?.some(
      ({code}) =>
        !selectedPlan?.code.toLowerCase().includes('mc_pro-5-thryv-m2m') &&
        (['mc_plus-5-thryv-m2m'].includes(code) ||
          selectedPlan?.code.toLowerCase().includes('mc_plus-5-thryv-m2m')),
    )
    const isMCProInCart = selectedCentersAndApps?.centers?.some(
      ({code}) =>
        ['mc_pro-5-thryv-m2m'].includes(code) ||
        selectedPlan?.code.toLowerCase().includes('mc_pro-5-thryv-m2m'),
    )
    const isMCFoundationInCart = selectedCentersAndApps.centers?.some(
      ({code: itemCode}) => isTgpFoundationFamilyCode(itemCode),
    )

    const isBCInCart = selectedCentersAndApps?.centers?.some(
      ({code}) =>
        [
          'bc_plus-5-thryv-m2m',
          'bc_pro-5-thryv-m2m',
          'bc_unlm-5-thryv-m2m',
        ].includes(code) ||
        [
          'bc_plus-5-thryv-m2m',
          'bc_pro-5-thryv-m2m',
          'bc_unlm-5-thryv-m2m',
        ].includes(selectedPlan?.code.toLowerCase()),
    )

    if (shouldTreatAsCenterPlan) {
      if (!isCommandCenter) {
        // const centerType = selectedPlan.code.split('_')[0]
        const existingCodes = [
          ...defaultCentersAndApps.centers.map(c => c.code),
          ...defaultCentersAndApps.apps.map(a => a.code),
        ]
        const cartCodesForFee = [
          ...selectedCentersAndApps.centers.map(c => c.code),
          ...selectedCentersAndApps.apps.map(a => a.code),
          selectedPlanWithOptions.code,
        ].filter((v, i, arr) => arr.indexOf(v) === i)
        // FULSAS-12295: a new Keap product makes thryvprfee a fresh charge,
        // not a duplicate of the Starter onboarding opt-in.
        const isKeapInCartForOnboardingFee = cartCodesForFee.some(code =>
          KEAP_FAMILY_CODES.includes(code),
        )

        const applicableFeeCodes = resolveApplicableFees(
          existingCodes,
          cartCodesForFee,
          oneTimeFees,
        )
        // Remove managed fees that are no longer applicable, keep non-catalog items
        const managedFeeCodes = new Set(oneTimeFees.map(f => f.code))
        data.oneTimes = data.oneTimes.filter(
          fee =>
            !managedFeeCodes.has(fee.code) ||
            applicableFeeCodes.includes(fee.code),
        )
        const feesToAdd = oneTimeFees
          .filter(fee => applicableFeeCodes.includes(fee.code))
          .filter(({code}) => !data.oneTimes.some(o => o.code === code))
          .filter(
            ({code}) =>
              !(
                code === 'thryvdesg2' &&
                (isWebsiteDesignFeeWaived ||
                  isMC20PlanSelected ||
                  mc20WebsiteDowngradeModalState ===
                    RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES)
              ),
          )
          .filter(
            ({code}) =>
              !(
                code === 'keap-ignite-thryvprfee' ||
                (code === 'thryvprfee' &&
                  (onboardingFeeRequired?.value === 'No' ||
                    (includeOnboarding?.value === 'Yes' &&
                      !isKeapInCartForOnboardingFee)))
              ),
          )
        const uniqueOneTimes = new Set([
          ...data.oneTimes,
          ...feesToAdd,
          ...(selectedPlanWithOptions.entitlements?.flatMap(
            ent => ent.applicableOneTimes,
          ) || []),
        ])

        const oneTimes = Array.from(uniqueOneTimes)
          .filter(fee => {
            if (
              fee?.code === 'thryvdesg2' &&
              (isWebsiteDesignFeeWaived ||
                isMC20PlanSelected ||
                mc20WebsiteDowngradeModalState ===
                  RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES)
            ) {
              return false
            }
            return true
          })
          .filter(
            (fee, i, arr) =>
              i ===
              arr.findIndex(item => {
                if (item && fee) return item.code === fee.code
                return false
              }),
          )
          .filter(Boolean)

        data.oneTimes = oneTimes
      }
      const isTLAlreadyAdded = data.apps.find(item =>
        item.name.includes('Thryv Leads'),
      )
      const isTL = selectedPlan.name.includes('Thryv Leads')
      if (isTL && isTLAlreadyAdded) {
        data.apps = data.apps.map(item => {
          if (item.name.includes('Thryv Leads')) {
            item = selectedPlanWithOptions
          }
          return item
        })
      } else {
        const {autoAddCenters = [], ...centerToAdd} = selectedPlanWithOptions
        data.centers.push(centerToAdd)
        if (autoAddCenters.length) {
          autoAddCenters.forEach(autoAddCenter => {
            const isCenterInOrder = data.centers.some(
              ({code}) => code === autoAddCenter.code,
            )
            if (isCenterInOrder) return
            if (autoAddCenter.code === 'rc-5-thryv-m2m') {
              // console.log(centerToAdd)
              // Don't auto add RC , incase of BC/MC upgrade or if RC Basic/Plus is already present
              let isBcMcUpgrade = false
              // console.log(
              //   'centerToAdd.name.toLowerCase().includes(business) : ',
              //   centerToAdd.name.toLowerCase().includes('business'),
              // )
              if (
                (centerToAdd.name.toLowerCase().includes('business') &&
                  isBCAlreadyPresent.length > 0) ||
                (centerToAdd.name.toLowerCase().includes('marketing') &&
                  isMCAlreadyPresent.length > 0)
              ) {
                isBcMcUpgrade = true
              }
              if (isRCAlreadyPresent.length > 0 || isBcMcUpgrade) {
                return
              }
            }
            data.centers.push(autoAddCenter)
          })
        }
      }
    } else if (selectedPlan.planType === 'app') {
      const existingCodesApp = [
        ...defaultCentersAndApps.centers.map(c => c.code),
        ...defaultCentersAndApps.apps.map(a => a.code),
      ]
      const cartCodesForFeeApp = [
        ...selectedCentersAndApps.centers.map(c => c.code),
        ...selectedCentersAndApps.apps.map(a => a.code),
        selectedPlanWithOptions.code,
      ].filter((v, i, arr) => arr.indexOf(v) === i)

      const applicableFeeCodesApp = resolveApplicableFees(
        existingCodesApp,
        cartCodesForFeeApp,
        oneTimeFees,
      )
      // Remove managed fees that are no longer applicable, keep non-catalog items
      const managedFeeCodesApp = new Set(oneTimeFees.map(f => f.code))
      data.oneTimes = data.oneTimes.filter(
        fee =>
          !managedFeeCodesApp.has(fee.code) ||
          applicableFeeCodesApp.includes(fee.code),
      )
      const feesToAddApp = oneTimeFees
        .filter(fee => applicableFeeCodesApp.includes(fee.code))
        .filter(({code}) => !data.oneTimes.some(o => o.code === code))
        .filter(
          ({code}) =>
            !(
              code === 'thryvdesg2' &&
              (isWebsiteDesignFeeWaived ||
                mc20WebsiteDowngradeModalState ===
                  RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES)
            ),
        )
      const uniqueOneTimes = new Set([
        ...data.oneTimes,
        ...feesToAddApp,
        ...(selectedPlanWithOptions.entitlements?.flatMap(
          ent => ent.applicableOneTimes,
        ) || []),
      ])
      const oneTimes = Array.from(uniqueOneTimes).filter(Boolean)

      data.oneTimes = oneTimes

      if (
        [
          'addon-5-keap-addcontacts-m2m',
          'addon-5-keap-addusers-m2m',
          'addon-5-keap-textvoice-m2m',
          'addon-5-keap-legacy-graphly-contacts-m2m',
          'addon-5-keap-legacy-plusthis-premium-trans-m2m',
          'addon-5-keap-addusers-annual',
          'addon-5-keap-addusers-annual',
          'addon-5-keap-textvoice-annual',
          'addon-5-keap-legacy-graphly-contacts-annual',
          'addon-5-keap-legacy-plusthis-premium-trans-annual',
        ].includes(selectedPlanWithOptions.code) &&
        data.apps.find(app => app.code === selectedPlanWithOptions.code)
      ) {
        data.apps = data.apps.filter(
          app => app.code != selectedPlanWithOptions.code,
        )
      }
      if (selectedPlanWithOptions.code === 'addon-5-mcexpangr') {
        data.apps = data.apps.filter(plan => plan.code !== 'addon-5-mcstartgr')
      }
      if (selectedPlanWithOptions.code.includes('addon-socialads')) {
        let isSocialAdsExist = data.apps.find(
          item => item.code === selectedPlanWithOptions.code,
        )
        if (isSocialAdsExist) {
          data.apps = data.apps.map(item => {
            if (item.code === selectedPlanWithOptions.code) {
              item.quantity = socialAdsQuantity
            }
            return item
          })
        } else {
          data.apps.push(selectedPlanWithOptions)
          // Trying to add Social Ads, when there's no MC but BC is present
          if (
            !isMCPlusInCart &&
            !isMCProInCart &&
            !isMCFoundationInCart &&
            !isMC20InCart &&
            isBCInCart &&
            selectedCountry === 'US'
          ) {
            data.centers.push(buildMcFoundationCenter())
          }
        }
      } else if (
        selectedPlanWithOptions?.code?.includes('addon-5-ai-webbuilder') //&&
        //data.apps.find(app => app.code === selectedPlan.code)
      ) {
        const isAiWebBuilderExist = data.apps.find(
          item => item.code === selectedPlanWithOptions.code,
        )

        if (isAiWebBuilderExist) {
          data.apps = data.apps.map(item => {
            if (item.code === selectedPlanWithOptions.code) {
              item.quantity = aiWebsiteBuilderQuantity
            }
            return item
          })
        } else {
          data.apps.push(selectedPlanWithOptions)
        }
      } else if (
        ['addon-ctn-bninat-m2m', 'addon-ctn-bninat-annual'].includes(
          selectedPlanWithOptions?.code,
        )
      ) {
        const isCtnExist = data.apps.find(
          item => item.code === selectedPlanWithOptions.code,
        )
        if (isCtnExist) {
          data.apps = data.apps.map(item => {
            if (item.code === selectedPlanWithOptions.code) {
              item.quantity = ctnQuantity
            }
            return item
          })
        } else {
          data.apps.push(selectedPlanWithOptions)
        }
      } else if (
        selectedPlan.code === 'addon-5-keap-addcontacts-m2m' &&
        data.apps.find(app => app.code === selectedPlan.code)
      ) {
        data.apps = data.apps.map(app => {
          if (app.code === 'addon-5-keap-addcontacts-m2m') {
            return {
              ...app,
              unitAmount:
                keapAdditionalContactsPrice > 0
                  ? keapAdditionalContactsPrice
                  : app.unitAmount,
              amount:
                keapAdditionalContactsPrice > 0
                  ? keapAdditionalContactsPrice
                  : app.unitAmount,
            }
          }
          return app
        })
      } else if (
        selectedPlan.code === 'addon-5-keap-addcontacts-annual' &&
        data.apps.find(app => app.code === selectedPlan.code)
      ) {
        data.apps = data.apps.map(app => {
          if (app.code === 'addon-5-keap-addcontacts-annual') {
            return {
              ...app,
              unitAmount:
                keapAdditionalContactsPriceAnnual > 0
                  ? keapAdditionalContactsPriceAnnual
                  : app.unitAmount,
              amount:
                keapAdditionalContactsPriceAnnual > 0
                  ? keapAdditionalContactsPriceAnnual
                  : app.unitAmount,
            }
          }
          return app
        })
      } else if (
        selectedPlan.code === 'addon-5-keap-textvoice-m2m' &&
        data.apps.find(app => app.code === selectedPlan.code)
      ) {
        data.apps = data.apps.map(app => {
          if (app.code === 'addon-5-keap-textvoice-m2m') {
            return {
              ...app,
              unitAmount:
                keapTextVoicePrice > 0 ? keapTextVoicePrice : app.unitAmount,
              amount:
                keapTextVoicePrice > 0 ? keapTextVoicePrice : app.unitAmount,
            }
          }
          return app
        })
      } else if (
        selectedPlan.code === 'addon-5-keap-addusers-m2m' &&
        data.apps.find(app => app.code === selectedPlan.code)
      ) {
        const keapAddons = all5PlanPrices?.apps?.find(
          a => a.code === 'addon-5-keap-addons',
        )
        const keapAddUsersAddon = keapAddons?.addons?.find(
          a => a.code === 'addon-5-keap-addusers-m2m',
        )
        const directAddon = all5PlanPrices?.apps?.find(
          a => a.code === 'addon-5-keap-addusers-m2m',
        )
        const currenciesSource =
          keapAddUsersAddon?.currencies ||
          directAddon?.currencies ||
          selectedPlan.currencies
        const {unitAmount: addUsersUnitAmount} = currenciesSource
          ? findUnitAmount(currenciesSource, selectedCountry, null)
          : {unitAmount: null}
        data.apps = data.apps.map(app => {
          if (app.code === 'addon-5-keap-addusers-m2m') {
            return {
              ...app,
              quantity,
              ...(addUsersUnitAmount != null && {
                unitAmount: addUsersUnitAmount,
                amount: addUsersUnitAmount,
              }),
            }
          }
          return app
        })
      } else if (
        ['seobase-5-thryv-m2m', 'tl-mc-5-thryv-m2m'].includes(
          selectedPlan.code,
        ) &&
        data.apps.find(app => app.code === selectedPlan.code)
      ) {
        data.apps = data.apps.map(app => {
          if (app.code === selectedPlan.code) {
            return selectedPlanWithOptions
          }
          return app
        })
      } else if (GEO_ADDON_CODES.includes(selectedPlanWithOptions.code)) {
        // FULSAS-13425: re-adding a Thryv Geo Expansion tier already in the
        // cart updates its quantity in place instead of pushing a duplicate
        // entry -- same pattern as CTN/AI web builder/Social Ads above.
        const isGeoExist = data.apps.find(
          item => item.code === selectedPlanWithOptions.code,
        )
        if (isGeoExist) {
          data.apps = data.apps.map(item => {
            if (item.code === selectedPlanWithOptions.code) {
              return {...item, quantity}
            }
            return item
          })
        } else {
          data.apps.push(selectedPlanWithOptions)
        }
      } else {
        data.apps.push(selectedPlanWithOptions)
      }
    } else {
      data.oneTimes.push(selectedPlanWithOptions)
    }
    //handle KeapMax HVAC
    const isMCPlusProInDefault = defaultCentersAndApps.centers.some(
      center =>
        center.code.includes('mc_plus-5-thryv-m2m') ||
        center.code.includes('mc_pro-5-thryv-m2m'),
    )
    const isHomeServicesDefault = defaultCentersAndApps?.apps?.some(app =>
      [
        'maxhvac-5-thryv-m2m',
        'maxroof-5-thryv-m2m',
        'maxelect-5-thryv-m2m',
        'maxplumb-5-thryv-m2m',
      ].includes(app.code),
    )
    const isHomeServicesInCart = selectedCentersAndApps?.apps?.some(app =>
      [
        'maxhvac-5-thryv-m2m',
        'maxroof-5-thryv-m2m',
        'maxelect-5-thryv-m2m',
        'maxplumb-5-thryv-m2m',
      ].includes(app.code),
    )
    const isMCPlusProPlan =
      selectedPlan?.code.toLowerCase().includes('mc_plus-5-thryv-m2m') ||
      selectedPlan?.code.toLowerCase().includes('mc_pro-5-thryv-m2m')
    let waiveHVACFees = false
    if (!isHomeServicesDefault && (isHomeServices || isHomeServicesInCart)) {
      if (isHomeServices || isMCPlusProPlan) {
        if (!isMCPlusProInDefault) {
          if (isMCPlusInCart || isMCProInCart) {
            if (isMCPlusInCart) {
              data.apps = data.apps.filter(
                app =>
                  app.code !== 'vert_clientsvcs-5-thryv-m2m' &&
                  app.code !== 'vert_mc_clientsvcs-5-thryv-m2m' &&
                  app.code !== 'vert_mc_web_clientsvcs-5-thryv-m2m',
              )
              data.oneTimes = data.oneTimes.filter(
                oneTime =>
                  oneTime.code !== 'vert_clientsvcs-5-thryv-ot' &&
                  oneTime.code !== 'vert_mc_clientsvcs-5-thryv-ot' &&
                  oneTime.code !== 'vert_mc_web_clientsvcs-5-thryv-ot',
              )
              switch (paymentType.value) {
                case 'oneTime':
                  data.oneTimes.push(hvacMcServicesOtAddOn)
                  break
                case '6Monthly':
                  data.apps.push(hvacMcServicesM2MAddOn)
                  break
                default:
                  break
              }
              waiveHVACFees = true
            } else if (isMCProInCart) {
              const mcProWebsite = selectedCentersAndApps.centers.find(
                center => center.code === 'mc_pro-5-thryv-m2m',
              )
              const selectedOptionsWebsite = selectedOptions.find(
                ({code}) => code === 'ent-5-website',
              )
              const websiteEnt = mcProWebsite?.entitlements?.find(
                ({code}) => code === 'ent-5-website',
              )

              waiveHVACFees = true
              if (!websiteEnt && !selectedOptionsWebsite) {
                data.apps = data.apps.filter(
                  app =>
                    app.code !== 'vert_clientsvcs-5-thryv-m2m' &&
                    app.code !== 'vert_mc_clientsvcs-5-thryv-m2m' &&
                    app.code !== 'vert_mc_web_clientsvcs-5-thryv-m2m',
                )
                data.oneTimes = data.oneTimes.filter(
                  oneTime =>
                    oneTime.code !== 'vert_clientsvcs-5-thryv-ot' &&
                    oneTime.code !== 'vert_mc_clientsvcs-5-thryv-ot' &&
                    oneTime.code !== 'vert_mc_web_clientsvcs-5-thryv-ot',
                )
                switch (paymentType.value) {
                  case 'oneTime':
                    data.oneTimes.push(hvacMcServicesOtAddOn)
                    break
                  case '6Monthly':
                    data.apps.push(hvacMcServicesM2MAddOn)
                    break
                  default:
                    break
                }
                waiveHVACFees = true
              } else {
                data.apps = data.apps.filter(
                  app =>
                    app.code !== 'vert_clientsvcs-5-thryv-m2m' &&
                    app.code !== 'vert_mc_clientsvcs-5-thryv-m2m' &&
                    app.code !== 'vert_mc_web_clientsvcs-5-thryv-m2m',
                )
                data.oneTimes = data.oneTimes.filter(
                  oneTime =>
                    oneTime.code !== 'vert_clientsvcs-5-thryv-ot' &&
                    oneTime.code !== 'vert_mc_clientsvcs-5-thryv-ot' &&
                    oneTime.code !== 'vert_mc_web_clientsvcs-5-thryv-ot',
                )
                switch (paymentType.value) {
                  case 'oneTime':
                    data.oneTimes.push(hvacMcServicesDesignOtAddOn)
                    break
                  case '6Monthly':
                    data.apps.push(hvacMcServicesDesignM2MAddOn)
                    break
                  default:
                    break
                }
                waiveHVACFees = true
              }
            }
          } else {
            data.apps = data.apps.filter(
              app =>
                app.code !== 'vert_clientsvcs-5-thryv-m2m' &&
                app.code !== 'vert_mc_clientsvcs-5-thryv-m2m' &&
                app.code !== 'vert_mc_web_clientsvcs-5-thryv-m2m',
            )
            data.oneTimes = data.oneTimes.filter(
              oneTime =>
                oneTime.code !== 'vert_clientsvcs-5-thryv-ot' &&
                oneTime.code !== 'vert_mc_clientsvcs-5-thryv-ot' &&
                oneTime.code !== 'vert_mc_web_clientsvcs-5-thryv-ot',
            )
            switch (paymentType.value) {
              case 'oneTime':
                data.oneTimes.push(hvacServicesOtAddOn)
                break
              case '6Monthly':
                data.apps.push(hvacServicesM2MAddOn)
                break
              default:
                break
            }
            waiveHVACFees = true
          }
        } else {
          data.apps = data.apps.filter(
            app =>
              app.code !== 'vert_clientsvcs-5-thryv-m2m' &&
              app.code !== 'vert_mc_clientsvcs-5-thryv-m2m' &&
              app.code !== 'vert_mc_web_clientsvcs-5-thryv-m2m',
          )
          data.oneTimes = data.oneTimes.filter(
            oneTime =>
              oneTime.code !== 'vert_clientsvcs-5-thryv-ot' &&
              oneTime.code !== 'vert_mc_clientsvcs-5-thryv-ot' &&
              oneTime.code !== 'vert_mc_web_clientsvcs-5-thryv-ot',
          )
          switch (paymentType.value) {
            case 'oneTime':
              data.oneTimes.push(hvacServicesOtAddOn)
              break
            case '6Monthly':
              data.apps.push(hvacServicesM2MAddOn)
              break
            default:
              break
          }
          waiveHVACFees = true
        }
      }
    }

    if (waiveHVACFees) {
      oneTimeFees = oneTimeFees.filter(
        ({code}) => code !== 'thryvprfee' && code !== 'thryvdesg2',
      )
      data.oneTimes = data.oneTimes.filter(
        ({code}) => code !== 'thryvprfee' && code !== 'thryvdesg2',
      )
    }
    //handle new AlphaSEO
    const isBCInDefault = defaultCentersAndApps.centers.some(({code}) =>
      BC_PLANS.includes(code),
    )
    const isMCInCart = selectedCentersAndApps.centers?.some(({code}) =>
      MC_PLANS.includes(code),
    )
    const hasTLInCart = data.apps.some(({code}) =>
      ['tl-mc-5-thryv-m2m', 'tl-tax-5-thryv-m2m', 'tl-5-thryv-m2m'].includes(
        code,
      ),
    )
    // Read against data.centers (post in-call pushes) so a Social-Ads-branch
    // push earlier in this same handleAddToOrder call is visible. Reading
    // isMCFoundationInCart (pre-call prop) here would double-push when the
    // user adds Social Ads while TL is already in the cart.
    const hasMcFoundationAfterAdds = data.centers.some(({code}) =>
      isTgpFoundationFamilyCode(code),
    )

    // FULSAS-9290 (GEP-6277): auto-add MC Foundation when SEO or Thryv Leads
    // is added to an existing BC-only US account. Social Ads handles its own
    // push below; SEO and TL share this block.
    if (
      (isNewSEO || hasTLInCart) &&
      !isMCInCart &&
      !isMC20InCart &&
      isBCInDefault &&
      !hasMcFoundationAfterAdds &&
      selectedCountry === 'US'
    ) {
      data.centers.push(buildMcFoundationCenter())
    }

    if (isNewSEO) {
      data.apps = data.apps.filter(
        app =>
          app.code !== 'addon-5-seokey-m2m' && app.code !== 'addon-5-seopb-m2m',
      )
      if (alphaKeyCount > 0)
        data.apps.push({
          id: 'sdfsd234j2fa',
          code: 'addon-5-seokey-m2m',
          name: 'SEO Keywords',
          quantity: alphaKeyCount,
          groupTitle: 'Thryv Add-Ons',
          unitAmount:
            selectedCountry === 'US'
              ? 400
              : selectedCountry === 'AU'
              ? 600
              : selectedCountry === 'CA'
              ? 500
              : 700,
          amount:
            selectedCountry === 'US'
              ? 400
              : selectedCountry === 'AU'
              ? 600
              : selectedCountry === 'CA'
              ? 500
              : 700,
          img: seoKeywordsIcon,
        })

      if (alphaPowerboostCount > 0)
        data.apps.push({
          id: 'sdfsd234jowio',
          code: 'addon-5-seopb-m2m',
          name: 'AEO & SEO PowerBoost',
          quantity: alphaPowerboostCount,
          groupTitle: 'Thryv Add-Ons',
          unitAmount:
            selectedCountry === 'US'
              ? 400
              : selectedCountry === 'AU'
              ? 600
              : selectedCountry === 'CA'
              ? 500
              : 700,
          amount:
            selectedCountry === 'US'
              ? 400
              : selectedCountry === 'AU'
              ? 600
              : selectedCountry === 'CA'
              ? 500
              : 700,
          img: seoPowerboostIcon,
        })
    }
    if (isLeadLift) {
      data.apps = data.apps.filter(app => app.code !== 'addon-5-leadslift-m2m')
      //Add keyword and powerboost products

      if (Number(picked?.amountNum ?? planAmountNum) > 1) {
        data.apps.push({
          id: 'addon5leadsliftm2m',
          code: 'addon-5-leadslift-m2m',
          name: 'Leads Lift',
          quantity:
            getAmountToQuantityMap(selectedCountry)[
              Math.round(
                Number(
                  String(picked?.amountNum ?? planAmountNum).replace(
                    /[^0-9.]/g,
                    '',
                  ),
                ),
              )
            ] ??
            (Math.floor(
              (Number(
                String(picked?.amountNum ?? planAmountNum).replace(
                  /[^0-9.]/g,
                  '',
                ),
              ) || 0) / (selectedCountry === 'NZ' ? 1 : 1.1),
            ) ||
              1),
          unitAmount: Number(picked?.amountNum ?? planAmountNum) || 1,
          groupTitle: 'Thryv Add-Ons',
          amount: Number(picked?.amountNum ?? planAmountNum) || 1,
          img: LeadsIcon,
        })
      }
    }

    // let BC_PLANS = [
    //   'bc_plus-5-thryv-m2m',
    //   'bc_pro-5-thryv-m2m',
    //   'bc_unlm-5-thryv-m2m',
    // ]

    data.centers.map(item => {
      if (BC_PLANS.includes(item.code)) {
        let uniqEnitlementCode = []
        item.entitlements = item.entitlements.filter(option => {
          if (uniqEnitlementCode.includes(option.code)) {
            return false
          } else {
            uniqEnitlementCode.push(option.code)
            return true
          }
        })
      }
      return item
    })

    // hasPaidOnboardingFee means the account already paid the BC/MC onboarding fee.
    // If Keap is in the cart (added now or in a prior step), thryvprfee is a NEW charge
    // for the Keap upgrade — not a duplicate — so we must not block it.
    const isKeapInCart = data.centers.some(c =>
      KEAP_FAMILY_CODES.includes(c.code),
    )
    let tempOneTimeCharges = data.oneTimes.filter(item => {
      if (item.code === 'thryvprfee' && hasPaidOnboardingFee && !isKeapInCart) {
        return false
      }
      if (
        item.code === 'thryvdesg2' &&
        (isWebsiteDesignFeeWaived ||
          mc20WebsiteDowngradeModalState ===
            RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES)
      ) {
        return false
      }
      if (
        item.code === 'keap-ignite-thryvprfee' ||
        (item.code === 'thryvprfee' &&
          (onboardingFeeRequired?.value === 'No' ||
            (includeOnboarding?.value === 'Yes' && !isKeapInCart)))
      ) {
        return false
      }
      return true
    })

    data.oneTimes = tempOneTimeCharges

    setSelectedCentersAndApps(data)
    setSelectedPlan(null)
    setSocialAdsQuantity(1)
    setAiWebsiteBuilderQuantity(1)
    setCtnQuantity(existingCtnQty)
    setSelectedOptions([])
    if (upgradePaymentPreview) setUpgradePaymentPreview(null)
    if (futureBillingDate) setFutureBillingDate(undefined)
    // console.log('End of handleAddToOrder - data :: ', data)
    // console.log('End of handleAddToOrder :: ', selectedCentersAndApps)
  }

  const handleChangeQuantity = value => {
    setQuantity(value)
  }

  const handleChangeLogoQty = event => {
    const qty = event.target.value
    if (isNaN(qty)) {
      toast.error('Please enter a number')
    } else if (qty > 100 || qty < 1) {
      toast.error('Please enter an amount between 1 and 100')
      setIsContinueDisableLogo(true)
    } else if (qty <= 100 && qty > 0) {
      setIsContinueDisableLogo(false)
    }
    setQuantity(qty)
  }

  const handleChangeQtyAnnual = event => {
    const qty = event.target.value
    let minValue =
      keapAddUsersRecurlyQtyAnnual && keapAddUsersRecurlyQtyAnnual > 0
        ? keapAddUsersRecurlyQtyAnnual
        : 1

    if (isNaN(qty) || qty === '') {
      toast.error('Please enter a number')
    } else if (qty > 99 || qty < minValue) {
      let msg = 'Please enter an amount between ' + minValue + ' and 99'
      toast.error(msg)
      setIsContinueDisableTMaxAddons(true)
      return // Do not update quantity on downgrade
    } else if (qty <= 99 && qty >= minValue) {
      setIsContinueDisableTMaxAddons(false)
      setQuantity(qty)
    }
  }

  const handleChangeQty = event => {
    const qty = event.target.value
    let minValue =
      keapAddUsersRecurlyQty && keapAddUsersRecurlyQty > 0
        ? keapAddUsersRecurlyQty
        : 1
    if (selectedPlan.code === 'addon-5-keap-addusers-m2m') {
      if (isNaN(qty) || qty === '') {
        toast.error('Please enter a number')
      } else if (qty > 99 || qty < minValue) {
        let msg = 'Please enter an amount between ' + minValue + ' and 99'
        toast.error(msg)
        setIsContinueDisableTMaxAddons(true)
        return // Do not update quantity on downgrade
      } else if (qty <= 99 && qty >= minValue) {
        setIsContinueDisableTMaxAddons(false)
        setQuantity(qty)
      }
    } else {
      if (isNaN(qty) || qty === '') {
        toast.error('Please enter a number')
      } else if (qty > 99 || qty < 1) {
        toast.error('Please enter an amount between 1 and 99')
        setIsContinueDisableTMaxAddons(true)
      } else if (qty <= 99 && qty > 0) {
        setIsContinueDisableTMaxAddons(false)
        setQuantity(qty)
      }
    }
    // Only call setQuantity for valid values; Keap Additional Users handled above with early return
    if (selectedPlan.code !== 'addon-5-keap-addusers-m2m') {
      setQuantity(qty)
    }
  }

  const handleChangeQty999 = event => {
    const qty = event.target.value
    if (isNaN(qty)) {
      toast.error('Please enter a number')
    } else if (qty > 999 || qty < 1) {
      toast.error('Please enter an amount between 1 and 999')
      setIsContinueDisableTMaxAddons(true)
    } else if (qty <= 999 && qty > 0) {
      setIsContinueDisableTMaxAddons(false)
    }
    setQuantity(qty)
  }

  const handleChangeQtyKccAnnual = event => {
    let minValue =
      kccRecurlyOption && kccRecurlyOption > 0 ? kccRecurlyOption : 1
    console.log('setSelectedPlan :: ', selectedPlan)
    const qty = event.target.value
    if (isNaN(qty)) {
      toast.error('Please enter a number')
    } else if (qty > 99 || qty < minValue) {
      toast.error('Please enter an amount between ' + minValue + ' and 99')
      setIsContinueDisableKccAnnual(true)
    } else if (qty <= 99 && qty > 0) {
      setIsContinueDisableKccAnnual(false)
    }
    setQuantity(qty)

    setSelectedPlan(prev => ({
      ...prev,
      entitlements: prev.entitlements.map(ent =>
        ent.code === 'addon-5-keap-partner-cert-sandbox-fee-annual'
          ? {...ent, quantity: qty}
          : ent,
      ),
    }))
  }

  const handlePriceChangeAdditionalContacts = event => {
    setKeapAdditionalContactsPrice(event.value.split('-')[1])
    // setQuantity(event.value.split('-')[0])
    setKeapAddContactsQty(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangeAdditionalContactsAnnual = event => {
    setKeapAdditionalContactsPriceAnnual(event.value.split('-')[1])
    setKeapAddContactsQtyAnnual(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangeAdditionalContactsGraphlyAnnual = event => {
    setKeapAdditionalContactsPriceGraphlyAnnual(event.value.split('-')[1])
    setKeapAddContactsQtyGraphlyAnnual(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangePlusThisPremiumAnnual = event => {
    setPlusThisPremiumPriceAnnual(event.value.split('-')[1])
    setPlusThisPremiumQtyGraphlyAnnual(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangeAdditionalContactsGraphlyM2m = event => {
    setKeapAdditionalContactsPriceGraphlyM2m(event.value.split('-')[1])
    setKeapAddContactsQtyGraphlyM2m(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangePlusThisPremiumM2m = event => {
    setPlusThisPremiumPriceM2m(event.value.split('-')[1])
    setPlusThisPremiumQtyGraphlyM2m(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangeTextVoice = event => {
    setKeapTextVoicePrice(event.value.split('-')[1])
    // setQuantity(event.value.split('-')[0])
    setKeapTextVoiceQty(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangeTextVoiceAnnual = event => {
    setKeapTextVoicePriceAnnual(event.value.split('-')[1])
    // setQuantity(event.value.split('-')[0])
    setKeapTextVoiceQtyAnnual(event.value.split('-')[0])
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: 1,
      amount: event.value.split('-')[1],
    }))
  }

  const handlePriceChangeKcpCertification = event => {
    setSelectedPlan(prev => ({
      ...prev,
      qunatity: event.value,
      amount: 1,
    }))
    setQuantity(event.value)
  }

  const renderContinueButton = () => {
    const isButtonDisabled =
      isContinueDisabledForThryvLeads ||
      isContinueDisabledForTLDomain ||
      isContinueDisabledForLLDomain ||
      quantity === 0 ||
      isContinueDisableLogo ||
      isContinueDisabledForAlphaSEO ||
      isContinueDisabledForKeapMax ||
      isContinueDisableTMaxAddons ||
      isContinueDisabledForLL ||
      isContinueDisabledKeapAdditionalContacts ||
      isContinueDisabledKeapAdditionalContactsAnnual ||
      isContinueDisabledKeapAdditionalContactsGraphlyAnnual ||
      isContinueDisabled ||
      isContinueDisabledKeapAdditionalContactsGraphlyM2m ||
      isContinueDisabledPlusThisPremiumM2m ||
      isContinueDisabledKeapTextVoice ||
      isContinueDisabledKeapTextVoiceAnnual ||
      isContinueDisabledForHomeServices ||
      //isContinueDisabledForMCTrial ||
      isContinueDisabledForMCTrialOnboarding ||
      isContinueDisabledForMC2OnboardingFee ||
      isContinueDisabledKcpCertification ||
      isContinueDisableKccAnnual

    const toastMessage =
      isMCProEnhanced && mcDomainConfig.isValid && !cohortEaid
        ? 'Invalid EAID- For Legacy Upgrades Only'
        : isHomeServices
        ? 'Valid Payment Type Required'
        : 'Valid Domain Required'

    const handleClick =
      (isContinueDisabledForMC ||
        isContinueDisabledForSEO ||
        isContinueDisabledForAlphaSEO ||
        isContinueDisabledForHomeServices ||
        isContinueDisabledForMCTrialOnboarding ||
        isContinueDisabledForMC2OnboardingFee) &&
      !isMCProEnhanced
        ? () => toast.error(toastMessage)
        : handleAddToOrder

    const buttonColor =
      (isContinueDisabledForMC ||
        isContinueDisabledForSEO ||
        isContinueDisabledForAlphaSEO ||
        isContinueDisabledForHomeServices ||
        isContinueDisabledForMCTrialOnboarding ||
        isContinueDisabledForMC2OnboardingFee) &&
      !isMCProEnhanced
        ? {color: '#a7a7a7'}
        : null

    return (
      <Button
        data-testid="add-to-order-button"
        variant="primary"
        buttonType="outlined"
        onClick={handleClick}
        disabled={
          isMCProEnhanced && selectedOptions.length < 1
            ? true
            : isButtonDisabled
        }
        style={buttonColor}
      >
        {isLeadLift && isUpgradeFlow && planAmountNum > 1
          ? 'Change Tier'
          : 'Add to Order'}
      </Button>
    )
  }

  function parseTier(str = '') {
    const m = String(str).match(/^(.*?)\s*-\s*\$?\s*([\d,]+(?:\.\d{1,2})?)\s*$/)
    const tierLabel = m?.[1]?.trim() || str.trim()
    const amountStr = m?.[2] || ''
    const amountNum = amountStr ? Number(amountStr.replace(/,/g, '')) : null
    return {tierLabel, amountStr, amountNum}
  }

  // === Leads Lift derived values ===
  // Resolve the existing subscription's dollar amount from the cart rather than
  // the catalog plan's amount, which may not reflect the customer's active tier.
  const existingLLApp = isLeadLift
    ? selectedCentersAndApps?.apps?.find(
        app => app.code === 'addon-5-leadslift-m2m',
      )
    : null

  const planAmountNum = React.useMemo(() => {
    if (!isLeadLift) return Number(selectedPlan?.amount ?? 0)
    // Recurly's stored amount may be fractional (e.g. 2999.7 instead of 3000)
    // and won't match tier options exactly. Always reverse-map from quantity
    // first to get the canonical tier dollar amount, then fall back to amount.
    if (Number(existingLLApp?.quantity) > 1) {
      const entries = Object.entries(getAmountToQuantityMap(selectedCountry))
      const closest = entries.reduce((prev, curr) =>
        Math.abs(curr[1] - existingLLApp.quantity) <
        Math.abs(prev[1] - existingLLApp.quantity)
          ? curr
          : prev,
      )
      return Number(closest[0])
    }
    if (Number(existingLLApp?.amount) > 1) return Number(existingLLApp.amount)
    return Number(selectedPlan?.amount ?? 0)
  }, [isLeadLift, existingLLApp, selectedPlan?.amount, selectedCountry])

  const filteredLeadLiftOptions = React.useMemo(() => {
    return searchOptions.map(opt => {
      const base = opt?.value ?? opt?.label ?? opt
      const {amountNum} = parseTier(base)
      const label = typeof opt === 'string' ? opt : opt.label ?? opt.value
      const value = typeof opt === 'string' ? opt : opt.value ?? opt.label
      let tag
      if (planAmountNum > 1 && amountNum != null) {
        if (amountNum > planAmountNum) tag = 'Upgrade'
        else if (amountNum === planAmountNum) tag = 'Current'
        else tag = 'Downgrade'
      }
      return tag ? {label, value, tag} : {label, value}
    })
  }, [planAmountNum, searchOptions])

  const effectiveLeadLiftAmount = React.useMemo(() => {
    const pickedAmt = picked?.amountNum ?? null
    if (pickedAmt != null) return pickedAmt
    if (planAmountNum > 1) return planAmountNum
    return null
  }, [planAmountNum, picked?.amountNum])

  useEffect(() => {
    const isWebsiteAppInCart = checkIfAdded(
      selectedCentersAndApps?.apps,
      'Professionally Designed Website',
      'app',
    )
    const isWebsiteEntInCart = checkIfAdded(
      selectedCentersAndApps?.centers,
      'Professionally Designed Website',
      'ent',
    )

    if (isWebsiteAppInCart && isWebsiteEntInCart) {
      const sensisSiteDomainInCart = selectedCentersAndApps.apps.find(
        ({code}) => code === 'addon-5-website_difm',
      )?.sensisSiteDomain
      const centerWithWebsiteEnt = selectedCentersAndApps?.centers?.find(
        ({entitlements}) =>
          entitlements?.some(({code}) => code === 'ent-5-website'),
      )
      const newEntitlements = centerWithWebsiteEnt?.entitlements?.map(ent => {
        if (ent.code === 'ent-5-website') {
          return {
            ...ent,
            ...(sensisSiteDomainInCart && {
              sensisSiteDomain: sensisSiteDomainInCart,
            }),
          }
        }
        return ent
      })
      const newCenterWithWebsiteEnt = {
        ...centerWithWebsiteEnt,
        entitlements: newEntitlements,
      }

      const newSelectedCentersAndApps = {
        ...selectedCentersAndApps,
        ...(sensisSiteDomainInCart && {
          centers: selectedCentersAndApps.centers.map(center => {
            if (center.code === centerWithWebsiteEnt.code) {
              return newCenterWithWebsiteEnt
            }
            return center
          }),
        }),
        apps: selectedCentersAndApps?.apps?.filter(
          ({code}) => code !== 'addon-5-website_difm',
        ),
      }
      setSelectedCentersAndApps(newSelectedCentersAndApps)
    }
    let isSocialAdsExist = selectedCentersAndApps?.apps?.find(
      item => item?.code === selectedPlan?.code,
    )
    if (isSocialAdsExist) {
      setSocialAdsQuantity(isSocialAdsExist.quantity || 1)
    }
    let isAIWebsiteExist = selectedCentersAndApps?.apps?.find(
      item => item?.code === selectedPlan?.code,
    )
    if (isAIWebsiteExist) {
      setAiWebsiteBuilderQuantity(isAIWebsiteExist.quantity || 1)
    }
    const CTN_CODES = ['addon-ctn-bninat-m2m', 'addon-ctn-bninat-annual']
    const isCtnInCart = selectedCentersAndApps?.apps?.find(item =>
      CTN_CODES.includes(item?.code),
    )
    const isCtnAlreadyIncluded = defaultCentersAndApps?.apps?.find(
      item => CTN_CODES.includes(item?.code) && item?.alreadyIncluded,
    )
    if (isCtnInCart) {
      setCtnQuantity(isCtnInCart.quantity || 1)
    } else if (isCtnAlreadyIncluded) {
      setCtnQuantity(isCtnAlreadyIncluded.quantity || 1)
    }
  }, [selectedCentersAndApps, setSelectedCentersAndApps])

  useEffect(() => {
    if (
      [
        RETAIN_WEBSITE_MODAL_STATES.ANSWERED_NO,
        RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES,
      ].includes(retainWebsiteModalState)
    ) {
      handleAddToOrder()
    }
  }, [retainWebsiteModalState])

  useEffect(() => {
    if (
      [
        RETAIN_WEBSITE_MODAL_STATES.ANSWERED_NO,
        RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES,
      ].includes(mc20WebsiteDowngradeModalState)
    ) {
      handleAddToOrder()
    }
  }, [mc20WebsiteDowngradeModalState])

  useEffect(() => {
    if (selectedPlan) {
      if (isThryvLeads) {
        setPlanPrice(
          formatPrice(thryvLeadsValidation?.budget || selectedPlan.amount),
        )
      } else if (selectedPlan.name.includes('SEO')) {
        setPlanPrice(
          formatPrice(proposalValidation?.price || selectedPlan.amount),
        )
      } else if (itemConfig?.hasInput || itemConfig?.hasSlider) {
        setPlanPrice(formatPrice(selectedPlan?.amount * quantity))
      } else if (isLeadLift && planAmountNum > 1) {
        setPlanPrice(formatPrice(planAmountNum))
      } else {
        setPlanPrice(formatPrice(selectedPlan.amount))
      }
    }
  }, [
    itemConfig?.hasInput,
    itemConfig?.hasSlider,
    quantity,
    selectedPlan,
    thryvLeadsValidation?.budget,
    proposalValidation?.price,
    isLeadLift,
    planAmountNum,
  ])

  const renderSocialAdsComponent = () => {
    return (
      <div className="mt-12">
        <QuantityComponent
          minQuantity={1}
          maxQuantity={5}
          currentCount={socialAdsQuantity}
          setCount={setSocialAdsQuantity}
        />
      </div>
    )
  }

  const renderAiWebsiteBuilderComponent = () => {
    return (
      <div className="mt-12">
        <QuantityComponent
          minQuantity={1}
          maxQuantity={99}
          currentCount={aiWebsiteBuilderQuantity}
          setCount={setAiWebsiteBuilderQuantity}
        />
      </div>
    )
  }
  const renderCtnComponent = () => {
    return (
      <div className="mt-12">
        <QuantityComponent
          minQuantity={existingCtnQty}
          maxQuantity={99}
          currentCount={ctnQuantity}
          setCount={setCtnQuantity}
        />
      </div>
    )
  }
  const isThryvSuccessServicesPlan =
    selectedPlan?.groupTitle === 'Thryv Success Services'
  return (
    <CatalogSectionContainer
      style={{
        padding: '17px 20px 0 20px',
        borderLeft: '1px solid #E3E6E8',
      }}
    >
      <ParagraphText className="mb-3 font-weight-bold" variant="lg">
        Options
      </ParagraphText>
      {selectedPlan && (
        <>
          <div
            className="options-info_container"
            data-testid="options-container"
            style={{
              width: '100%',
            }}
          >
            <img
              src={
                isThryvSuccessServicesPlan
                  ? thryvSucessServicesIcon
                  : selectedPlan?.img
              }
              alt="plan logo"
              height={64}
              width={64}
              className="options-logo"
            />
            <div
              style={{
                width: '100%',
              }}
            >
              <ParagraphText
                variant="lg"
                style={{margin: 0}}
                className="font-weight-bold"
              >
                {isThryvSuccessServicesPlan
                  ? selectedPlan?.groupTitle
                  : selectedPlan?.name}
              </ParagraphText>
              {selectedPlan?.code?.includes('addon-socialads') ? (
                <ParagraphText variant="reg" style={{margin: 0}}>
                  {formatPrice(selectedPlan?.amount * socialAdsQuantity)}
                </ParagraphText>
              ) : selectedPlan?.code?.includes('addon-5-ai-webbuilder') ? (
                <ParagraphText variant="reg" style={{margin: 0}}>
                  {formatPrice(selectedPlan?.amount * aiWebsiteBuilderQuantity)}
                </ParagraphText>
              ) : ['addon-ctn-bninat-m2m', 'addon-ctn-bninat-annual'].includes(
                  selectedPlan?.code,
                ) ? (
                <ParagraphText variant="reg" style={{margin: 0}}>
                  {formatPrice(selectedPlan?.amount * ctnQuantity)}
                </ParagraphText>
              ) : isThryvSuccessServicesPlan ? (
                <ParagraphText
                  variant="reg"
                  style={{
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>{selectedPlan?.name}</span>
                  <span>{planPrice}</span>
                </ParagraphText>
              ) : (
                <ParagraphText variant="reg" style={{margin: 0}}>
                  {isSEO && !proposalValidation ? 'Varies' : planPrice}
                </ParagraphText>
              )}
            </div>
          </div>
          {isWorkforceCenter && (
            <ParagraphText
              variant="reg"
              style={{marginTop: 8, color: '#5378FC'}}
            >
              Review/Approval can take up to 3 business days, after filling out
              the Company Onboarding wizard
            </ParagraphText>
          )}
          {selectedPlan?.code.includes('addon-socialads') &&
            renderSocialAdsComponent()}
          {selectedPlan?.code.includes('addon-5-ai-webbuilder') &&
            renderAiWebsiteBuilderComponent()}
          {['addon-ctn-bninat-m2m', 'addon-ctn-bninat-annual'].includes(
            selectedPlan?.code,
          ) && renderCtnComponent()}
          <div style={{paddingLeft: '15px'}}>
            {selectedPlan?.entitlements
              ?.filter(ent => {
                const isSocialContentSelected = selectedOptions.some(
                  option => option.name === 'Social Content Generation',
                )
                const isBCUnlimitedSelected =
                  selectedPlan?.code === 'bc_unlm-5-thryv-m2m'
                const isBCProfessionalIncluded =
                  defaultCentersAndApps?.centers?.find(
                    ({code}) => code === 'bc_pro-5-thryv-m2m',
                  )
                const purchasedBeforeCutoff =
                  isBCProfessionalIncluded &&
                  dayjs(isBCProfessionalIncluded?.createdAt).isBefore(
                    '02-08-2024',
                  )
                const isSCG = ent.code === 'ent-5-socialcontentgen'

                if (
                  isBCProfessionalIncluded &&
                  !isBCUnlimitedSelected &&
                  !purchasedBeforeCutoff &&
                  isSCG
                ) {
                  return false
                }

                if (
                  !isBCUnlimitedSelected &&
                  !isBCProfessionalIncluded &&
                  isSCG
                ) {
                  return false
                }

                if (ent.name === 'Social Boost' && !isSocialContentSelected) {
                  return false
                }
                if (
                  ent.requiresFlags?.length > 0 &&
                  !ent.requiresFlags.some(flag => userFeatures[flag])
                ) {
                  return false
                }
                return true
              })
              .map(option => {
                const isWebsiteAddedAsEnt = checkIfAdded(
                  selectedCentersAndApps.centers,
                  'Professionally Designed Website',
                  'ent',
                )
                const isWebsiteAddedAsApp = checkIfAdded(
                  selectedCentersAndApps.apps,
                  'Professionally Designed Website',
                  'app',
                )
                const isGPOOptionAdded = checkIfAdded(
                  selectedCentersAndApps.centers,
                  'Google Business Profile Optimization',
                  'ent',
                )
                const isOptionIncluded = selectedCentersAndApps.centers.some(
                  ({entitlements}) =>
                    entitlements?.some(
                      ({name, alreadyIncluded}) =>
                        name === option.name && alreadyIncluded,
                    ),
                )

                const isOptionSelected =
                  selectedOptions.find(
                    current => current.name === option.name,
                  ) !== undefined

                const isWebsiteOptionDisabled =
                  option.name === 'Professionally Designed Website' &&
                  isWebsiteAddedAsEnt
                const isGBPOptionDisabled =
                  option.name === 'Google Business Profile Optimization' &&
                  isGPOOptionAdded
                const isWebsiteEntDisabled =
                  option.name === 'Professionally Designed Website' &&
                  isWebsiteAddedAsApp
                const isMC20OptionalEntitlement =
                  (MC_2_0_SIGPREMIERPLANS.includes(selectedPlan?.code) &&
                    [
                      'ent-keap-included-contacts',
                      'ent-keap-included-user',
                    ].includes(option.code)) ||
                  (MC_2_0_SIGNATUREPLANS.includes(selectedPlan?.code) &&
                    option.code === 'ent-5-website')
                const isEntDisabled =
                  (!isMC20OptionalEntitlement &&
                    isOptionIncluded &&
                    option.code !=
                      'addon-5-keap-partner-cert-sandbox-fee-annual') ||
                  isWebsiteEntDisabled ||
                  (!isMC20OptionalEntitlement && option.isRequired)

                return (
                  <React.Fragment key={option.code}>
                    <div className="d-flex align-items-center justify-content-between">
                      {isEntDisabled ? (
                        <Checkbox
                          isChecked={true}
                          disabled={true}
                          value={option}
                          label={
                            <label style={{color: '#808080', margin: 0}}>
                              {formatEntitlementLabel(
                                option.name,
                                option.quantity,
                                isCanAusNz,
                              )}
                            </label>
                          }
                          hasLabel={true}
                        />
                      ) : (
                        <Checkbox
                          data-testid={`select-option-${option.name}`}
                          isChecked={selectedOptions.some(
                            selectedOption =>
                              selectedOption.name === option.name,
                          )}
                          disabled={
                            isWebsiteOptionDisabled || isGBPOptionDisabled
                          }
                          value={option}
                          onChange={() => handleSelectOption(option)}
                          label={
                            <label
                              style={{
                                color: '#808080',
                                margin: 0,
                                textDecorationLine:
                                  isWebsiteOptionDisabled || isGBPOptionDisabled
                                    ? 'line-through'
                                    : 'none',
                              }}
                            >
                              {formatEntitlementLabel(
                                option.name,
                                option.quantity,
                                isCanAusNz,
                              )}
                            </label>
                          }
                          hasLabel={true}
                        />
                      )}
                      <ParagraphText
                        variant="reg"
                        style={{margin: 0, marginBottom: '0.5rem'}}
                      >
                        {option.amount}
                      </ParagraphText>
                    </div>
                    {isOptionSelected &&
                      option?.applicableOneTimes
                        .filter(fee => {
                          if (fee.code === 'thryvdesg2') {
                            if (isWebsiteDesignFeeWaived) return false
                            if (
                              MC_2_0_SIGPREMIERPLANS.includes(
                                selectedPlan?.code,
                              )
                            )
                              return false
                          }
                          return true
                        })
                        .map(ent => (
                          <div
                            key={ent.code}
                            className="d-flex align-items-center justify-content-between"
                          >
                            <Checkbox
                              isChecked={true}
                              disabled={true}
                              value={ent}
                              label={
                                <label style={{color: '#808080', margin: 0}}>
                                  {ent.name}
                                </label>
                              }
                              hasLabel={true}
                            />
                            <ParagraphText
                              variant="reg"
                              style={{margin: 0, marginBottom: '0.5rem'}}
                            >
                              {formatPrice(ent.amount)}
                            </ParagraphText>
                          </div>
                        ))}
                  </React.Fragment>
                )
              })}
          </div>
          {selectedPlan?.tier && (
            <>
              <div className="d-flex" style={{columnGap: '8px'}}>
                <ParagraphText variant="reg" className="font-weight-bold">
                  Seat amount:
                </ParagraphText>
                <ParagraphText variant="reg">{seatQty}</ParagraphText>
              </div>
              <div className="d-flex" style={{columnGap: '8px'}}>
                <ParagraphText variant="reg" className="font-weight-bold">
                  Price per seat:
                </ParagraphText>
                <ParagraphText variant="reg">
                  {formatPrice(selectedPlan?.tier.unitAmount)}
                </ParagraphText>
              </div>
            </>
          )}
          {isNewSEO && (
            <SEOSummary
              alphaSEOFromRecurly={alphaSEOFromRecurly}
              alphaProposalId={alphaProposalId}
              setAlphaProposalId={setAlphaProposalId}
              alphaDomain={alphaDomain}
              setAlphaDomain={setAlphaDomain}
              alphaAmount={alphaAmount}
              setAlphaAmount={setAlphaAmount}
              // categories={categories}
              // setCategories={setCategories}
              // geos={geos}
              // setGeos={setGeos}
              isExternalDomain={isExternalDomain}
              setIsExternalDomain={setIsExternalDomain}
              alphaKeyCount={alphaKeyCount}
              setAlphaKeyCount={setAlphaKeyCount}
              alphaPowerboostCount={alphaPowerboostCount}
              setAlphaPowerboostCount={setAlphaPowerboostCount}
              diableValidateAndProposalInput={diableValidateAndProposalInput}
              seoBillingDate={futureBillingDate}
              setSeoBillingDate={setFutureBillingDate}
              selectedCentersAndApps={selectedCentersAndApps}
              defaultCentersAndApps={defaultCentersAndApps}
              isSEOAlreadyIncluded={isSEOAlreadyIncluded}
            ></SEOSummary>
          )}
          {isSEO && (
            <SEOValidation
              setProposalId={setProposalId}
              proposalId={proposalId}
              proposalValidation={proposalValidation}
              setProposalValidation={setProposalValidation}
              seoBillingDate={futureBillingDate}
              setSeoBillingDate={setFutureBillingDate}
              isNonMBG={selectedPlan?.name === 'SEO Non-Guaranteed'}
              selectedCountry={selectedCountry}
              isSEOMBGDisabled={isSEOMBGDisabled}
              setIsSEOMBGDisabled={setIsSEOMBGDisabled}
              selectedCentersAndApps={selectedCentersAndApps}
              recommendedSEOPrice={recommendedSEOPrice}
              convertSeoNg={convertSeoNg}
              seoDomainConfig={seoDomainConfig}
              setSeoDomainConfig={setSeoDomainConfig}
            />
          )}
          {isPlanInKeapFamily && (
            <KeapDomainValidation
              isKeapMax={true}
              isFreeTrailCustomer={isFreeTrailCustomer}
              setIsFreeTrailCustomer={setIsFreeTrailCustomer}
              setKeapDomainConfig={setKeapDomainConfig}
              keapDomainConfig={keapDomainConfig}
              keapTrailAppId={keapTrailAppId}
              setKeapTrailAppId={setKeapTrailAppId}
            />
          )}
          {isHomeServices && (
            <PaymentTypeValidation
              setPaymentType={setPaymentType}
              paymentType={paymentType}
            />
          )}
          {isPaidMCTrial &&
            !isMCTrialOnboardingRequired &&
            !isMCTrialOnboardingFeeRequired && (
              <>
                <DomainValidation
                  setDomainConfig={setMcDomainConfig}
                  domainConfig={mcDomainConfig}
                  validExtensionList={validExtensionList}
                  isOptional
                />
              </>
            )}
          {showIncludeOnboardingToggle && (
            <>
              <ParagraphText variant="reg" className="font-weight-bold">
                {'Growth Package Options'}
              </ParagraphText>
              <IncludeOnboardingToggle
                includeOnboarding={includeOnboarding}
                setIncludeOnboarding={setIncludeOnboarding}
              />
            </>
          )}
          {isPaidMCTrial && isMCTrialOnboardingRequired && (
            <>
              <OnboardingRequired
                setOnboardingRequired={setOnboardingRequired}
                onboardingRequired={onboardingRequired}
              />
              <DomainValidation
                setDomainConfig={setMcDomainConfig}
                domainConfig={mcDomainConfig}
                validExtensionList={validExtensionList}
                isOptional
              />
            </>
          )}
          {isPaidMCTrial && isMCTrialOnboardingFeeRequired && (
            <>
              <OnboardingFeeRequired
                setOnboardingFeeRequired={setOnboardingFeeRequired}
                onboardingFeeRequired={onboardingFeeRequired}
              />
              <DomainValidation
                setDomainConfig={setMcDomainConfig}
                domainConfig={mcDomainConfig}
                validExtensionList={validExtensionList}
                isOptional
              />
            </>
          )}
          {isMarketingCenter && !isPaidMCTrial && !isMCProEnhanced && (
            <>
              <DomainValidation
                setDomainConfig={setMcDomainConfig}
                domainConfig={mcDomainConfig}
                validExtensionList={validExtensionList}
              />
              {selectedCountry === 'US' && (
                <EaidValidation
                  cohortEaid={cohortEaid}
                  isEaidFound={isEaidFound}
                  isOptional={selectedPlan.code !== 'mc_pro_enh-5-thryv-m2m'}
                  setCohortEaid={setCohortEaid}
                  setIsEaidFound={setIsEaidFound}
                  setAllowInvoice={setAllowInvoice}
                  setIsCohort={setIsCohort}
                  isMCProEnhanced={isMCProEnhanced}
                  setIsLegacyUpgradeAllowed={setIsLegacyUpgradeAllowed}
                  thryvId={thryvId}
                />
              )}
            </>
          )}

          {isLeadLift && (
            <>
              <div className="mx-auto max-w-lg space-y-3 p-1 -mt-1">
                <h4 className="text-base font-semibold">
                  {isUpgradeFlow && planAmountNum > 1
                    ? 'Change Tier'
                    : 'Search Tier'}
                </h4>

                <SearchDropdown
                  options={filteredLeadLiftOptions}
                  onSelect={opt => {
                    const base = opt?.value ?? opt?.label ?? ''
                    const {tierLabel, amountStr, amountNum} = parseTier(base)
                    setPicked({...opt, tierLabel, amountStr, amountNum})
                    setLLpicked(false)
                  }}
                  placeholder={
                    effectiveLeadLiftAmount != null
                      ? `Search Tiers > $${Number(
                          effectiveLeadLiftAmount,
                        ).toLocaleString()}…`
                      : 'Search Tier…'
                  }
                />

                {/* Selected display */}
                {effectiveLeadLiftAmount != null && (
                  <div className="rounded-none border border-gray-200 p-3 text-sm text-gray-700">
                    <strong>Selected:</strong>{' '}
                    {Number(effectiveLeadLiftAmount).toLocaleString()}
                  </div>
                )}

                <p className="text-xs text-gray-500">
                  Tip: try typing “st”, “ex”, “50”, etc.
                </p>
              </div>
            </>
          )}
          {isLeadLiftBni && (
            <ParagraphText
              variant="reg"
              style={{marginTop: 8, color: '#5378FC'}}
            >
              Usage-based product — final charges apply once usage is
              calculated.
            </ParagraphText>
          )}
          {isLeadLift && isMC20InCart && (
            <DomainValidation
              setDomainConfig={setLlDomainConfig}
              domainConfig={llDomainConfig}
              validExtensionList={validExtensionList}
            />
          )}
          {isThryvLeads && (
            <ThryvLeadsValidation
              thryvLeadsId={thryvLeadsId}
              setThryvLeadsId={setThryvLeadsId}
              thryvLeadsValidation={thryvLeadsValidation}
              setThryvLeadsValidation={setThryvLeadsValidation}
              thryvLeadsBillingDate={futureBillingDate}
              setThryvLeadsBillingDate={setFutureBillingDate}
              isEaidFound={isEaidFound}
              setIsEaidFound={setIsEaidFound}
              cohortEaid={cohortEaid}
              setCohortEaid={setCohortEaid}
              country={selectedCountry}
              setAllowInvoice={setAllowInvoice}
              thryvLeadAlreadyExist={thryvLeadAlreadyExist}
              thryvId={thryvId}
            />
          )}
          {isThryvLeads && isMC20InCart && (
            <DomainValidation
              setDomainConfig={setTlDomainConfig}
              domainConfig={tlDomainConfig}
              validExtensionList={validExtensionList}
            />
          )}
          {itemConfig?.hasSlider && (
            <SliderRange
              key={selectedPlan.name}
              product={selectedPlan}
              handleOnChange={handleChangeQuantity}
              maxValue={itemConfig.max}
              range={itemConfig.range}
              symbolTemplate={''}
              includeProduct={true}
              lastValidValue={quantity}
              minValue={existingGeoQty}
            />
          )}
          {itemConfig?.hasInput && (
            <Input
              className="w-50"
              type="number"
              value={quantity}
              onChange={handleChangeLogoQty}
              max={100}
              min={1}
              size={1}
              placeholder="Please enter a number between 1-100"
              aria-label="Please enter a number between 1-100"
              name="number"
              withLabel
              labelType="floating"
              variant="default"
            />
          )}
          {(isHourlyDataService || isKeapAdditionalUsers) && (
            <Input
              className="w-50"
              type="number"
              value={quantity}
              onChange={handleChangeQty}
              max={99}
              min={
                isKeapAdditionalUsers &&
                keapAddUsersRecurlyQty &&
                keapAddUsersRecurlyQty > 0
                  ? keapAddUsersRecurlyQty
                  : 1
              }
              size={1}
              placeholder={
                isKeapAdditionalUsers &&
                keapAddUsersRecurlyQty &&
                keapAddUsersRecurlyQty > 0
                  ? 'Please enter a number between ' +
                    keapAddUsersRecurlyQty +
                    '-99'
                  : 'Please enter a number between 1-99'
              }
              aria-label="Please enter a number between 1-99"
              name="number"
              withLabel
              labelType="floating"
              variant="default"
            />
          )}
          {isKeapAdditionalUsersAnnual && (
            <Input
              className="w-50"
              type="number"
              value={quantity}
              onChange={handleChangeQtyAnnual}
              max={99}
              min={
                keapAddUsersRecurlyQtyAnnual && keapAddUsersRecurlyQtyAnnual > 0
                  ? keapAddUsersRecurlyQtyAnnual
                  : 1
              }
              size={1}
              placeholder={
                keapAddUsersRecurlyQtyAnnual && keapAddUsersRecurlyQtyAnnual > 0
                  ? 'Please enter a number between ' +
                    keapAddUsersRecurlyQtyAnnual +
                    '-99'
                  : 'Please enter a number between 1-99'
              }
              aria-label="Please enter a number between 1-99"
              name="number"
              withLabel
              labelType="floating"
              variant="default"
            />
          )}
          {isCustomDoneForYou && (
            <Input
              className="w-50"
              type="number"
              value={quantity}
              onChange={handleChangeQty999}
              max={999}
              min={1}
              size={1}
              placeholder="Please enter a number between 1-999"
              aria-label="Please enter a number between 1-999"
              name="number"
              withLabel
              labelType="floating"
              variant="default"
            />
          )}
          {isKccCertificationAnnual && (
            <>
              <br></br>
              <Input
                className="w-50"
                type="number"
                value={
                  kccRecurlyOption && kccRecurlyOption > quantity
                    ? kccRecurlyOption
                    : quantity
                }
                onChange={handleChangeQtyKccAnnual}
                max={99}
                min={
                  kccRecurlyOption && kccRecurlyOption > 0
                    ? kccRecurlyOption
                    : 1
                }
                size={1}
                placeholder="Please enter a number between 1-99"
                aria-label="Please enter a number between 1-99"
                name="number"
                withLabel
                labelType="floating"
                variant="default"
              />
            </>
          )}
          {isKeapAdditionalContacts && (
            <Select
              selectLabel="Select quantity"
              options={ADDITIONAL_CONTACT_OPTIONS}
              width="full"
              onChange={handlePriceChangeAdditionalContacts}
              selectedOption={selectedAdditionalContactOption}
              setSelectedOption={setSelectedAdditionalContactOption}
            />
          )}
          {isKeapAdditionalContactsAnnual && (
            <Select
              selectLabel="Select quantity"
              options={ADDITIONAL_CONTACT_OPTIONS_ANNUAL}
              width="full"
              onChange={handlePriceChangeAdditionalContactsAnnual}
              selectedOption={selectedAdditionalContactOptionAnnual}
              setSelectedOption={setSelectedAdditionalContactOptionAnnual}
            />
          )}
          {isKeapAdditionalContactsGraphlyAnnual && (
            <Select
              selectLabel="Select quantity"
              options={ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_ANNUAL}
              width="full"
              onChange={handlePriceChangeAdditionalContactsGraphlyAnnual}
              selectedOption={selectedAdditionalContactOptionGraphlyAnnual}
              setSelectedOption={
                setSelectedAdditionalContactOptionGraphlyAnnual
              }
            />
          )}
          {isKeapPlusThisPremiumAnnual && (
            <Select
              selectLabel="Select quantity"
              options={PLUS_THIS_PREMIUM_ANNUAL}
              width="full"
              onChange={handlePriceChangePlusThisPremiumAnnual}
              selectedOption={selectedPlusThisPremiumAnnual}
              setSelectedOption={setSelectedPlusThisPremiumAnnual}
            />
          )}
          {isKeapAdditionalContactsGraphlyM2m && (
            <Select
              selectLabel="Select quantity"
              options={ADDITIONAL_CONTACT_OPTIONS_GRAPHLY_M2M}
              width="full"
              onChange={handlePriceChangeAdditionalContactsGraphlyM2m}
              selectedOption={selectedAdditionalContactOptionGraphlyM2m}
              setSelectedOption={setSelectedAdditionalContactOptionGraphlyM2m}
            />
          )}
          {isKeapPlusThisPremiumM2m && (
            <Select
              selectLabel="Select quantity"
              options={PLUS_THIS_PREMIUM_M2M}
              width="full"
              onChange={handlePriceChangePlusThisPremiumM2m}
              selectedOption={selectedPlusThisPremiumM2m}
              setSelectedOption={setSelectedPlusThisPremiumM2m}
            />
          )}
          {isKeapTextVoice && (
            <Select
              selectLabel="Select quantity"
              options={KEAP_TEXT_VOICE_OPTIONS}
              width="md"
              onChange={handlePriceChangeTextVoice}
              selectedOption={selectedKeapTextVoice}
              setSelectedOption={setSelectedKeapTextVoice}
            />
          )}
          {isKeapTextVoiceAnnual && (
            <Select
              selectLabel="Select quantity"
              options={KEAP_TEXT_VOICE_OPTIONS_ANNUAL}
              width="md"
              onChange={handlePriceChangeTextVoiceAnnual}
              selectedOption={selectedKeapTextVoiceAnnual}
              setSelectedOption={setSelectedKeapTextVoiceAnnual}
            />
          )}
          {isKcpCertification && (
            <Select
              selectLabel="Select price option"
              options={KCP_OPTIONS}
              width="md"
              onChange={handlePriceChangeKcpCertification}
              selectedOption={selectedKcpOption}
              setSelectedOption={setSelectedKcpOption}
            />
          )}
          <div
            className="d-flex justify-content-end"
            style={{paddingTop: '25px'}}
          >
            {renderContinueButton()}
          </div>
        </>
      )}
      <WebsiteSettingsModal
        isWebsiteSettingsModalVisible={isWebsiteSettingsModalVisible}
        setIsWebsiteSettingsModalVisible={setIsWebsiteSettingsModalVisible}
        setSensisSiteDomain={setSensisSiteDomain}
        isWebsiteValid={isWebsiteValid}
        setIsWebsiteValid={setIsWebsiteValid}
      />
      <RetainWebsiteModal
        state={retainWebsiteModalState}
        setState={setRetainWebsiteModalState}
      />
      <RetainWebsiteDowngradeModal
        isOpen={
          mc20WebsiteDowngradeModalState === RETAIN_WEBSITE_MODAL_STATES.OPEN
        }
        downgradedFrom={mc20WebsiteDowngradePlanName}
        onConfirm={answer => {
          if (answer === null) {
            setMc20WebsiteDowngradeModalState(RETAIN_WEBSITE_MODAL_STATES.CLOSE)
            return
          }
          setMc20WebsiteDowngradeModalState(
            answer === 'yes'
              ? RETAIN_WEBSITE_MODAL_STATES.ANSWERED_YES
              : RETAIN_WEBSITE_MODAL_STATES.ANSWERED_NO,
          )
        }}
      />
    </CatalogSectionContainer>
  )
}

export {Options}
